import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import {
  Box,
  Card,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import { default as Checkbox } from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTextField from "../../../../components/CustomTextField";
import { default as CustomSelect } from "../../../../components/Select/Select";
import {
  addBillingItemsByPaymentId,
  applyTotalDiscountByPayAndDetailId,
  deletePaymentItemById,
  enableCheckoutByAppointmentId,
  getAllDiscountCodes,
  getBillDetailsByPaymentId,
  getClinicFacilities,
  getClinicStocks,
  getLocations,
  getServices,
  updateBillCheckDetails,
  updateBillingByPaymentId,
  updateBillingItemsByPaymentId,
  updateDiscountCodeById,
  updatePayment,
} from "../../../../redux/reducers/clinicSlice";
import { getPetsCompliantSummary } from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";
import {
  dropDiscountTypes,
  radioDiscountTypes,
} from "../../../../util/arrayList";
import {
  billingPharmacyCategoryList,
  posPetShopCategoryList,
  posPharmacyCategoryList,
} from "../../../../util/CommonArrays";
import {
  delBtn,
  w20h20BlueIcon,
  w20h20GreenIcon,
} from "../../../../util/CommonIconStyle";
import {
  discountTypes,
  PaymentTypeList,
  RMVPaymentTypeList,
} from "../../../../util/dropList";
import {
  getBorderColor,
  getDiscountCodeAvailableToday,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getPrevDiscountValues,
  getRightPackageUom,
  getTaxAndSubTotalAndTotal,
  getTaxAndSubTotalAndTotalForTreatment,
  getTreatmentRecordBasedType,
  reorderList,
  roundWithSignedDiff,
} from "../../../../util/function";
import { tblGrayBack } from "../../../../util/object";
import { RMVClinicId } from "../../../../util/server";
import PaymentModeDropdown from "../../../CommonComponents/PaymentModeDropdown";
import BillingPreview from "../../../CommonScreens/BillingPreview/BillingPreview";
import "./Billing.css";

const phrTblHdrs = [
  "serviceitemname",
  "qty",
  "unitPrice",
  "discount",
  "tax",
  "total",
  "pay",
];

const tableNameExpan = {
  serviceitemname: "Service/Item Name",
  qty: "Qty",
  unitPrice: "Unit Price",
  tax: "Tax",
  adminCharge: "Admin Charge",
  total: "Item Total",
  days: "Days",
  discount: "Unit Discount",
};

const initialValues = {
  quantity: 1,
  price: 0,
  unitType: "Unit",
  discountType: discountTypes?.[0],
  linkToProcedure: null,
};
const initialPayValues = {
  amount: "",
  paymentMode: { name: "Cash", value: "cash" },
};
const initDis = { type: "code", amt: "", discountCode: null };
const initialPayments = {
  subTotal: 0,
  tax: "-",
  discount: 0,
  amtPaid: 0,
  balDue: 0,
};
const initShows = { showSublineItems: true, showSublinePrice: true };

const Billing = ({ bill }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const contentToPrint = useRef(null);
  const [activeTab, setActiveTab] = useState("Treatment");
  const [selectedItem, setSelectedItem] = useState(null);
  const [editModVsble, setEditModVsble] = useState(false);
  const [disValues, setDisValues] = useState(initDis);
  const [disErrs, setDisErrs] = useState({});
  const [searchVisible, setSearchVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [disModVsble, setDisModVsble] = useState(false);
  const [delModVisible, setDelModVisible] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState(initialPayments);
  const [searchValue, setSearchValue] = useState("");
  const [itemValues, setItemValues] = useState(initialValues);
  const [billedByValues, setBilledByValues] = useState({
    billedBy: null,
    error: "",
  });
  const [prntPrevVsble, setPrntPrevVsble] = useState(false);
  const [payModalVisible, setPayModalVisible] = useState(false);
  const [payValues, setPayValues] = useState(initialPayValues);
  const [payErr, setPayErr] = useState({});
  const [enabledPaymentTypes, setEnabledPaymentTypes] =
    useState(PaymentTypeList);
  const [totalBalanceDue, setTotalBalanceDue] = useState(0);
  const [showValues, setShowValues] = useState(initShows);
  const appDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const clinicDet = useSelector((state) => state?.clinic?.details);
  const stocks = useSelector((state) => state?.clinic?.clinicStocks);
  const {
    services,
    billDetails,
    discountCodes,
    petBilling,
    locationList,
    facilities,
  } = useSelector((state) => state?.clinic);
  const lastSummary = useSelector((state) => state?.pet?.lastSummary?.data);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const petDet = appDet?.pet;
  const apnt = appDet?.appointment;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (bill?.paymentId ?? petDet?.paymentId) {
      dispatch(getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId));
    }
    dispatch(getClinicStocks());
    getProductAndServiceListForDropdown();
    // if (bill?.appointmentId) {
    //   dispatch(getCompliantSummaryByIdWoLoader(bill?.appointmentId));
    // }
    dispatch(getLocations());
    dispatch(getClinicFacilities());
    getDiscountCodeList();
  }, []);

  useEffect(() => {
    getPaymentDetails();
    setShowValues({
      showSublineItems: billDetails?.showSublineItems,
      showSublinePrice: billDetails?.showSublinePrice,
    });
    if (
      billDetails?.appointmentStatus?.toLowerCase() === "finalize" &&
      (billDetails?.checkOut !== "Y" ||
        billDetails?.pharmacyCheckout !== "Y" ||
        billDetails?.pharmacyCheckout !== "Y")
    ) {
      setBilledByValues({
        billedBy: {
          name: billDetails?.billedByName ?? profile?.name,
          value: billDetails?.billedById ?? profile?.id,
        },
        error: false,
      });
    }
    // if (billDetails?.billedById && billDetails?.billedByName) {
    //   setBilledByValues({
    //     ...itemValues,
    //     billedBy: {
    //       name: billDetails?.billedByName,
    //       value: billDetails?.billedById,
    //     },
    //   });
    // }
  }, [billDetails]);

  const getTabBasedRecords = () => {
    return activeTab === "Treatment"
      ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
      : activeTab === "Pet Shop"
        ? getPetShopRecordBasedType(billDetails?.paymentDetails)
        : getPharmacyRecordBasedType(billDetails?.paymentDetails);
  };

  const getDiscountCodeList = () => {
    dispatch(getAllDiscountCodes());
  };

  const getUnitPriceAndTotalForService = (itm) => {
    const li = itm;
    let reqList = [];
    if (li?.serviceId && li?.variantId && !li?.patientWorkbook) {
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === li?.serviceId,
      );
      const reqVarnt = reqServ?.serviceVariants?.find(
        (vnt) => vnt?.variantId === li?.variantId,
      );
      if (reqVarnt?.serviceDetails?.length > 0) {
        const filteredDetails =
          reqVarnt?.serviceDetails?.filter(
            (lit) =>
              (lit?.alterType === "N" && !lit?.alterName) ||
              (lit?.alterType === "Y" && !lit?.alterName),
          ) || [];

        filteredDetails.forEach((lit) => {
          // Check if item already exists to prevent duplicates
          const existingItem = reqList.find(
            (item) =>
              item?.serviceId === lit?.serviceId &&
              item?.variantId === lit?.variantId &&
              item?.name === lit?.name,
          );

          if (!existingItem) {
            reqList.push({
              ...lit,
              estCost: lit?.estimatedCost,
              serviceId: lit?.serviceId,
              variantId: lit?.variantId,
              serviceCharge: reqVarnt?.serviceCharge ?? 0,
            });
          }
        });
      }
      if (reqVarnt?.servicePrescreiptions?.length > 0) {
        const filteredPrescriptions =
          reqVarnt?.servicePrescreiptions?.filter(
            (lit) =>
              (lit?.alterType === "N" && !lit?.alterName) ||
              (lit?.alterType === "Y" && !lit?.alterName),
          ) || [];

        filteredPrescriptions.forEach((lit, i) => {
          // Check if item already exists to prevent duplicates
          const existingItem = reqList.find(
            (item) =>
              item?.serviceId === li?.serviceId &&
              item?.variantId === li?.variantId &&
              item?.name === lit?.name,
          );

          if (!existingItem) {
            const admnObj = {
              ...lit,
              estCost: lit?.estimatedCost ?? 0,
              serviceId: li?.serviceId,
              variantId: li?.variantId,
              serviceCharge: reqVarnt?.serviceCharge ?? 0,
            };
            reqList.push(admnObj);
          }
        });
      }

      reqList = reqList
        ?.map((lit) => ({
          ...lit,
          subItemName: lit?.name,
          serviceitemname: lit?.name,
          qty: lit?.quantity,
          unitPrice: lit?.estimatedCost ?? lit?.estCost,
          discount: 0,
          adminCharge: 0,
          total: lit?.estimatedCost ?? lit?.estCost,
        }))
        // Remove duplicates from reqList
        .filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (reqItem) =>
                reqItem.subItemName === item.subItemName &&
                reqItem.serviceId === item.serviceId &&
                reqItem.variantId === item.variantId,
            ),
        );
    } else {
      if (li?.serviceId) {
        const reqSer = lastSummary?.procedures?.find(
          (pl) => pl?.serviceId === li?.serviceId,
        );
        const reqActSer = services?.data?.find(
          (ser) => ser?.serviceId === li?.serviceId,
        );
        const reqVar = reqActSer?.serviceVariants?.find(
          (vnt) => vnt?.variantId === li?.variantId,
        );
        if (reqSer?.procedureDetails?.length > 0) {
          reqList = reqSer?.procedureDetails?.map((lit) => ({
            ...lit,
            subItemName: lit?.procedureName,
            serviceitemname: lit?.procedureName,
            qty: lit?.quantity,
            unitPrice: lit?.estimatedCost,
            discount: 0,
            adminCharge: 0,
            total: lit?.estimatedCost,
            serviceCharge: reqVar?.serviceCharge ?? 0,
          }));
        }
      }
    }
    const reqTotal =
      activeTab === "Treatment"
        ? reqList?.length > 0
          ? Number(
              reqList
                ?.filter((rl) => (li?.variantId ? true : rl?.status === "true"))
                ?.reduce((acc, rl) => acc + Number(rl?.total), 0) +
                Number(reqList?.[0]?.serviceCharge ?? 0),
            ) - Number(li?.mrpDiscount ?? 0)
          : li?.total
        : li?.total;
    return {
      total: reqTotal,
      unitPrice: Number(reqList?.[0]?.serviceCharge ?? 0),
      totalWithoutDiscount: reqTotal + Number(li?.mrpDiscount ?? 0),
      reqList,
    };
  };

  const getUsedDiscountCodes = () => {
    if (activeTab === "Treatment") {
      if (billDetails?.treatmentDiscountId?.length > 0) {
        const reqList = billDetails?.treatmentDiscountId
          ?.map((li) => {
            const match = discountCodes?.find(
              (dc) => dc?.billId?.toString() === li,
            );
            return match;
          })
          ?.filter(Boolean); // remove undefined if no match found
        return reqList;
      }
      return [];
    }
    if (activeTab === "Pharmacy") {
      if (billDetails?.pharmacyDiscountId?.length > 0) {
        const reqList = billDetails?.pharmacyDiscountId
          ?.map((li) => {
            const match = discountCodes?.find(
              (dc) => dc?.billId?.toString() === li,
            );
            return match;
          })
          ?.filter(Boolean); // remove undefined if no match found
        return reqList;
      }
      return [];
    }
    if (activeTab === "Pet Shop") {
      if (billDetails?.petShopDiscountId?.length > 0) {
        const reqList = billDetails?.petShopDiscountId
          ?.map((li) => {
            const match = discountCodes?.find(
              (dc) => dc?.billId?.toString() === li,
            );
            return match;
          })
          ?.filter(Boolean); // remove undefined if no match found
        return reqList;
      }
      return [];
    }
  };

  const getAutoDiscountCodes = () => {
    return discountCodes?.filter(
      (dc) => dc?.discountMethod === "Automatic discount",
    );
  };

  const getPaymentDetails = () => {
    let subTotal = 0,
      tax = 0,
      discount = 0,
      balDue = 0;
    if (billDetails?.paymentDetails?.length > 0) {
      billDetails?.paymentDetails?.forEach((pd) => {
        tax = tax + Number(pd?.tax) ?? 0;
        subTotal = subTotal + pd?.total;
      });
    }
    if (disValues?.type && Number(disValues?.amt) > 0) {
      if (disValues?.type?.toLowerCase() === "price") {
        discount = Number(disValues?.amt);
      }
      if (disValues?.type?.toLowerCase() === "percentage") {
        discount = (subTotal / 100) * Number(disValues?.amt);
      }
    }
    balDue = subTotal - (discount + billDetails?.amtPaid);
    setPaymentDetails({ ...paymentDetails, subTotal, tax, discount, balDue });
  };

  const getProductAndServiceListForDropdown = () => {
    let reqServices = [];
    dispatch(getServices()).then((res) => {
      if (res?.payload?.data?.length > 0) {
        reqServices = res?.payload?.data?.map((ser) => {
          return {
            ...ser,
            name: ser?.serviceName,
            value: ser?.serviceId,
            type: "Service",
          };
        });
      }
      setServiceList(reqServices);
    });
  };

  const handleDelete = (bill) => {
    setSelectedItem(bill);
    setDelModVisible(true);
  };

  const handleDelConfirm = () => {
    dispatch(deletePaymentItemById(selectedItem?.paymentDetailId)).then(
      (res) => {
        if (res?.payload) {
          handleUpdatePaymentValues();
          setSelectedItem(null);
          setDelModVisible(false);
        }
      },
    );
  };

  const handleEdit = (bill) => {
    const reqStck = stocks?.data?.find((stc) => stc?.stockId === bill?.stockId);
    const reqBat = reqStck?.stockBatch?.find(
      (btch) => btch?.batchId === bill?.batchId,
    );
    const reqUOm = reqBat?.packageUom?.match(/^(\d+)(.+)/);
    const reqUnitPrice = Number(
      Number(bill?.price ?? 0) /
        Number(
          bill?.type?.toLowerCase() === "administered"
            ? Number(reqUOm?.[1] ?? 1)
            : 1,
        ),
    );
    const reqObj = {
      ...itemValues,
      ...bill,
      name: bill?.name,
      quantity: bill?.quantity,
      price: Number(bill?.mrpPrice ?? bill?.price)?.toFixed(2),
      tax: bill?.tax,
      serviceId: bill?.serviceId ?? null,
      productId: bill?.productId ?? null,
      unitType: bill?.subUnit ?? "Unit",
      adminCharge: "N",
      adminChargeAmount: 0,
      paymentDetailId: bill?.paymentDetailId,
      discount: bill?.mrpDiscount ?? bill?.discount,
      discountType:
        bill?.discountType === "pe" ? discountTypes?.[0] : discountTypes?.[1],
      stockId: bill?.stockId,
      batchId: bill?.batchId,
      batchNumber: reqBat
        ? {
            name: reqBat?.batchNo,
            value: reqBat?.batchId,
            batchId: reqBat?.batchId,
          }
        : null,
      variantNumber: bill?.variantNumber,
      variantId: bill?.variantId,
      type: bill?.type,
      hsnSacCode: bill?.hsnSacCode ?? null,
      drugSchedule: bill?.drugSchedule ?? null,
      packageUom: bill?.packageUom ?? null,
      expiryDate: bill?.expiryDate ?? null,
      batchNo: bill?.batchNo ?? null,
    };
    if (activeTab === "Treatment" && bill?.stockId) {
      reqObj.linkToProcedure = null;
      if (bill?.procedureId) {
        const reqProced = getProcedureList()?.find(
          (li) => li?.apiValue === bill?.procedureId,
        );
        reqObj.linkToProcedure = reqProced ?? null;
      }
    }
    // if (bill?.discountType === "pe") {
    //   const reqPercent = (Number(bill?.discount) / Number(bill?.price)) * 100;
    //   reqObj.discount = reqPercent;
    // }
    if (bill?.discountType) {
      reqObj.discountType =
        bill?.discountType === "pe"
          ? dropDiscountTypes?.[1]
          : dropDiscountTypes?.[2];
      if (bill?.discountType === "pe") {
        const reqPercent =
          (Number(bill?.mrpDiscount ?? bill?.discount) / Number(reqUnitPrice)) *
          100;
        reqObj.discountValue = reqPercent;
      } else {
        reqObj.discountValue = bill?.discount ?? 0;
      }
    } else {
      reqObj.discountType = dropDiscountTypes?.[2];
      // const reqPercent =
      //   Number(
      //     Number(bill?.mrpDiscount ?? bill?.discount ?? 0) /
      //       Number(bill?.price ?? 0)
      //   ) * 100;
      reqObj.discountValue = 0;
      // isNaN(reqPercent) ? 0 : reqPercent;
    }
    setItemValues(reqObj);
    setSelectedItem(bill);
    setEditVisible(false);
    // setEditVisible(true);
    setEditModVsble(true);
  };

  const onDiscountModClose = () => {
    setDisModVsble(false);
    setDisErrs({});
    setDisValues(initDis);
  };

  const onChangeDiscount = (name, value) => {
    const errs = {};
    setDisValues({ ...disValues, [name]: value });
    if (name === "amt") {
      errs.amt =
        value?.length > 0
          ? Number(value) > 0
            ? ""
            : "Value must be positive"
          : "This field is required";
    }
    setDisErrs(errs);
  };

  const onChangeItemValue = (name, value, addObj) => {
    const reqObj = { ...itemValues, [name]: value };
    if (name === "batchNumber" && addObj) {
      reqObj.batchId = addObj?.batchId;
    }
    if (name === "discountType") {
      reqObj.discountValue = value?.value?.toLowerCase() === "code" ? null : 0;
    }
    setItemValues(reqObj);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setSelectedItem(null);
  };

  const getBillQty = () => {
    return (
      getTabBasedRecords()?.reduce((acc, curr) => acc + curr?.quantity, 0) ?? 0
    );
  };

  const getDiscountCodes = () => {
    const todayDiscounts = getDiscountCodeAvailableToday(
      discountCodes,
      billDetails?.userId ?? null,
      (activeTab === "Treatment"
        ? getTaxAndSubTotalAndTotalForTreatment(
            getTreatmentRecordBasedType(billDetails?.paymentDetails),
            services?.data,
            lastSummary?.procedures ?? [],
          )
        : activeTab === "Pharmacy"
          ? getTaxAndSubTotalAndTotal(
              getPharmacyRecordBasedType(billDetails?.paymentDetails),
            )
          : getTaxAndSubTotalAndTotal(
              getPetShopRecordBasedType(billDetails?.paymentDetails),
            )
      )?.subTotal ?? 0,
      getBillQty(),
      petBilling?.totalRecords === 1 || !petBilling?.totalRecords,
      (activeTab === "Treatment"
        ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
        : activeTab === "Pharmacy"
          ? getPharmacyRecordBasedType(billDetails?.paymentDetails)
          : getPetShopRecordBasedType(billDetails?.paymentDetails)
      )?.some((li) => Number(li?.discount ?? 0) > 0),
      appDet?.pet?.ownershipType ?? null,
    );
    return todayDiscounts?.map((dc) => ({
      name: dc?.discountCode,
      value: dc?.discountCode,
      discountType: dc?.discountType,
      discountValue: dc?.discountValue,
      purchaseType: dc?.purchaseType,
      billingId: dc?.billId,
      limitUsagePerCustomer: dc?.limitUsagePerCustomer,
      limitUsageTotal: dc?.limitUsageTotal,
    }));
  };

  const handleAddDiscount = (isRemoveDiscount = false) => {
    const errs = {};
    if (disValues?.type === "code") {
      errs.discountCode = disValues?.discountCode?.value
        ? ""
        : "This field is required";
    }
    if (disValues?.type !== "code") {
      errs.amt =
        disValues?.amt?.length > 0
          ? Number(disValues?.amt) > 0
            ? ""
            : "Value must be positive"
          : "This field is required";
    }
    if (
      !isRemoveDiscount &&
      ((disValues?.type === "code" && errs?.discountCode?.length > 0) ||
        (disValues?.type !== "code" && errs?.amt?.length > 0))
    ) {
      return setDisErrs(errs);
    }
    const reqDiscountType = isRemoveDiscount
      ? "percentage"
      : disValues?.type?.toLowerCase() === "code"
        ? disValues?.discountCode?.discountType?.toLowerCase()
        : disValues?.type?.toLowerCase();
    const reqDiscountValue = isRemoveDiscount
      ? 0
      : disValues?.type === "code"
        ? disValues?.discountCode?.discountValue
        : disValues?.amt;

    const applyDiscount = getTabBasedRecords()?.map((li) => {
      const reqObj = {
        paymentDetailsId: li?.paymentDetailId,
        discount: 0,
        percentage: reqDiscountType === "percentage" ? "pe" : "pr",
        price: 0,
        mrpPrice: 0,
        mrpDiscount: 0,
        tax: 0,
        total: 0,
        quantity: li?.quantity,
      };
      const reqStck = stocks?.data?.find((stc) => stc?.stockId === li?.stockId);
      const reqBat = reqStck?.stockBatch?.find(
        (btch) => btch?.batchId === li?.batchId,
      );
      if (reqBat) {
        const taxPerent =
          (activeTab === "Pharmacy"
            ? clinicDet?.pharmacyTaxId
            : activeTab === "Treatment"
              ? clinicDet?.taxId
              : clinicDet?.petShopTaxId
          )?.length > 0
            ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
            : 0;
        const reqPercent = 100 + Number(taxPerent);
        const unitPrice = Number(reqBat?.unitSellingPrice) / (reqPercent / 100);
        const discount =
          reqDiscountType !== "percentage"
            ? Number(
                Number(
                  (Number(unitPrice) /
                    Number(
                      (activeTab === "Treatment"
                        ? getTaxAndSubTotalAndTotalForTreatment(
                            getTreatmentRecordBasedType(
                              billDetails?.paymentDetails,
                            ),
                            services?.data,
                            lastSummary?.procedures ?? [],
                          )
                        : activeTab === "Pharmacy"
                          ? getTaxAndSubTotalAndTotal(
                              getPharmacyRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                            )
                          : getTaxAndSubTotalAndTotal(
                              getPetShopRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                            )
                      )?.subTotal -
                        (activeTab === "Treatment"
                          ? getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                              services?.data,
                              lastSummary?.procedures ?? [],
                            )
                          : activeTab === "Pharmacy"
                            ? getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                            : getTaxAndSubTotalAndTotal(
                                getPetShopRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                        )?.tax +
                        (activeTab === "Treatment"
                          ? getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                              services?.data,
                              lastSummary?.procedures ?? [],
                            )
                          : activeTab === "Pharmacy"
                            ? getTaxAndSubTotalAndTotalForTreatment(
                                getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                                services?.data,
                                lastSummary?.procedures ?? [],
                              )
                            : getTaxAndSubTotalAndTotalForTreatment(
                                getPetShopRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                                services?.data,
                                lastSummary?.procedures ?? [],
                              )
                        )?.discount,
                    )) *
                    Number(reqDiscountValue),
                ) * Number(li?.quantity),
              )
            : (Number(
                Number(Number(unitPrice ?? 0) / 100) *
                  Number(reqDiscountValue ?? 0),
              ) ?? 0);
        const priceAfterDiscount = Number(unitPrice) - Number(discount);
        const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
        reqObj.price = unitPrice;
        reqObj.discount = discount;
        reqObj.tax = Number(taxValue ?? 0) * Number(li?.quantity);
        reqObj.total =
          Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
          Number(li?.quantity);
        reqObj.mrpPrice = Number(reqBat?.unitSellingPrice);
        reqObj.mrpDiscount = discount;
      }
      if (li?.serviceId) {
        const unitPrice = li?.price;
        const reqServ = services?.data?.find(
          (ser) => ser?.serviceId === li?.serviceId,
        );
        const discount =
          reqDiscountType !== "percentage"
            ? Number(
                Number(
                  Number(unitPrice) /
                    Number(
                      (activeTab === "Treatment"
                        ? getTaxAndSubTotalAndTotalForTreatment(
                            getTreatmentRecordBasedType(
                              billDetails?.paymentDetails,
                            ),
                            services?.data,
                            lastSummary?.procedures ?? [],
                          )
                        : activeTab === "Pharmacy"
                          ? getTaxAndSubTotalAndTotal(
                              getPharmacyRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                            )
                          : getTaxAndSubTotalAndTotal(
                              getPetShopRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                            )
                      )?.subTotal -
                        (activeTab === "Treatment"
                          ? getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                              services?.data,
                              lastSummary?.procedures ?? [],
                            )
                          : activeTab === "Pharmacy"
                            ? getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                            : getTaxAndSubTotalAndTotal(
                                getPetShopRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                        )?.tax +
                        (activeTab === "Treatment"
                          ? getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                              services?.data,
                              lastSummary?.procedures ?? [],
                            )
                          : activeTab === "Pharmacy"
                            ? getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                            : getTaxAndSubTotalAndTotal(
                                getPetShopRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                        )?.discount,
                    ),
                ) * Number(reqDiscountValue),
              ) * Number(li?.quantity)
            : (Number(
                Number(Number(unitPrice ?? 0) / 100) *
                  Number(reqDiscountValue ?? 0),
              ) ?? 0);
        reqObj.price = Number(unitPrice ?? 0);
        const taxPerent =
          reqServ?.taxApplicability?.toLowerCase() === "yes"
            ? Number(reqServ?.tax ?? 0)
            : 0;
        const priceAfterDiscount =
          Number(unitPrice ?? 0) - Number(discount ?? 0);
        const taxValue =
          Number(taxPerent / 100) * Number(priceAfterDiscount ?? 0);
        const priceWithTax =
          Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0);
        reqObj.discount = discount;
        reqObj.total = Number(priceWithTax ?? 0) * Number(li?.quantity);
        reqObj.tax = Number(taxValue ?? 0) * Number(li?.quantity);
        reqObj.mrpPrice = Number(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      if (!li?.serviceId && !li?.stockId) {
        const unitPrice = li?.price;
        const discount =
          (reqDiscountType !== "percentage"
            ? Number(
                Number(
                  Number(
                    Number(unitPrice) /
                      Number(
                        (activeTab === "Treatment"
                          ? getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                              services?.data,
                              lastSummary?.procedures ?? [],
                            )
                          : activeTab === "Pharmacy"
                            ? getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                            : getTaxAndSubTotalAndTotal(
                                getPetShopRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                        )?.subTotal -
                          (activeTab === "Treatment"
                            ? getTaxAndSubTotalAndTotalForTreatment(
                                getTreatmentRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                                services?.data,
                                lastSummary?.procedures ?? [],
                              )
                            : activeTab === "Pharmacy"
                              ? getTaxAndSubTotalAndTotal(
                                  getPharmacyRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                )
                              : getTaxAndSubTotalAndTotal(
                                  getPetShopRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                )
                          )?.tax +
                          (activeTab === "Treatment"
                            ? getTaxAndSubTotalAndTotalForTreatment(
                                getTreatmentRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                                services?.data,
                                lastSummary?.procedures ?? [],
                              )
                            : activeTab === "Pharmacy"
                              ? getTaxAndSubTotalAndTotal(
                                  getPharmacyRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                )
                              : getTaxAndSubTotalAndTotal(
                                  getPetShopRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                )
                          )?.discount,
                      ),
                  ) * Number(reqDiscountValue ?? 0),
                ),
              )
            : (Number(
                Number(Number(unitPrice ?? 0) / 100) *
                  Number(reqDiscountValue ?? 0),
              ) ?? 0)) * Number(li?.quantity);
        reqObj.price = Number(unitPrice ?? 0);
        reqObj.tax = 0;
        reqObj.discount = discount;
        reqObj.total =
          (Number(unitPrice ?? 0) - Number(discount ?? 0)) *
          Number(li?.quantity);
        reqObj.mrpPrice = Number(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      return reqObj;
    });
    const data = {
      applyDiscount,
      treatmentDiscountType:
        activeTab === "Treatment"
          ? reqDiscountType === "percentage"
            ? "pe"
            : "pr"
          : (billDetails?.treatmentDiscountType ?? "pr"),
      treatmentDiscountValue:
        activeTab === "Treatment"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.treatmentDiscountValue ?? 0),
      pharmacyDiscountType:
        activeTab === "Pharmacy"
          ? reqDiscountType === "percentage"
            ? "pe"
            : "pr"
          : (billDetails?.pharmacyDiscountType ?? "pr"),
      pharmacyDiscountValue:
        activeTab === "Pharmacy"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.pharmacyDiscountValue ?? 0),
      petShopDiscountType:
        activeTab === "Pet Shop"
          ? reqDiscountType === "percentage"
            ? "pe"
            : "pr"
          : (billDetails?.petShopDiscountType ?? "pr"),
      petShopDiscountValue:
        activeTab === "Pet Shop"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.petShopDiscountValue ?? 0),
    };
    if (disValues?.discountCode?.value) {
      data.billingId = disValues?.discountCode?.billingId;
      data.purchaseType = "oneTime";
      data.pharmacyDiscountId =
        activeTab === "Pharmacy"
          ? uniq([
              ...(billDetails?.pharmacyDiscountId ?? []),
              disValues?.discountCode?.billingId?.toString(),
            ])
          : (billDetails?.pharmacyDiscountId ?? []);
      data.treatmentDiscountId =
        activeTab === "Treatment"
          ? uniq([
              ...(billDetails?.treatmentDiscountId ?? []),
              disValues?.discountCode?.billingId?.toString(),
            ])
          : (billDetails?.treatmentDiscountId ?? []);
      data.petShopDiscountId =
        activeTab === "Pet Shop"
          ? uniq([
              ...(billDetails?.petShopDiscountId ?? []),
              disValues?.discountCode?.billingId?.toString(),
            ])
          : (billDetails?.petShopDiscountId ?? []);
    }
    dispatch(
      applyTotalDiscountByPayAndDetailId({
        paymentId:
          bill?.paymentId ?? billDetails?.paymentId ?? petDet?.paymentId,
        data,
      }),
    ).then((res) => {
      if (res?.payload) {
        if (disValues?.discountCode?.limitUsageTotal) {
          const reqDis = discountCodes?.find(
            (dc) => dc?.billId === disValues?.discountCode?.billingId,
          );
          const reqObj = {
            discountMethod: reqDis?.discountMethod,
            startDate: !isNaN(Date.parse(reqDis?.startDate))
              ? moment(new Date(reqDis?.startDate)).format("YYYY-MM-DD")
              : null,
            endDate: !isNaN(Date.parse(reqDis?.endDate))
              ? moment(new Date(reqDis?.endDate)).format("YYYY-MM-DD")
              : null,
            discountCode: reqDis?.discountCode,
            discountType: reqDis?.discountType,
            discountValue: reqDis?.discountValue,
            applieTo: reqDis?.applieTo,
            purchaseType: reqDis?.purchaseType,
            categories: reqDis?.categories,
            minRequirementType: reqDis?.minRequirementType,
            minAmount: reqDis?.minAmount,
            minQuantity: reqDis?.minQuantity,
            specificCustomers: reqDis?.specificCustomers,
            limitUsageTotal: reqDis?.limitUsageTotal,
            maxTotalUses: disValues?.discountCode?.limitUsageTotal
              ? (Number(Number(reqDis?.maxTotalUses) - 1) ?? 0)
              : reqDis?.maxTotalUses,
            limitUsagePerCustomer: reqDis?.limitUsagePerCustomer,
            maxPerCustomerUses: disValues?.discountCode?.limitUsagePerCustomer
              ? (Number(Number(reqDis?.maxPerCustomerUses) - 1) ?? 0)
              : reqDis?.maxPerCustomerUses,
            cannotBeCombined: reqDis?.cannotBeCombined,
            isActive: reqDis?.active,
          };
          dispatch(
            updateDiscountCodeById({
              id: disValues?.discountCode?.billingId,
              data: reqObj,
            }),
          );
        }
        handleUpdatePaymentValues();
        onDiscountModClose();
        getDiscountCodeList();
      }
    });
  };

  const handleUpdatePaymentValues = async () => {
    dispatch(
      getBillDetailsByPaymentId(
        location?.state?.bill?.paymentId ??
          bill?.paymentId ??
          petDet?.paymentId,
      ),
    ).then(async (res) => {
      const pay = res?.payload;

      let subTotal = 0,
        tax = 0,
        discount = 0;

      if (pay?.paymentDetails?.length > 0) {
        pay?.paymentDetails?.forEach((pd) => {
          tax = tax + Number(pd?.tax) ?? 0;
          subTotal = subTotal + pd?.total;
        });

        const pharRecCount =
          getPharmacyRecordBasedType(pay?.paymentDetails)?.length ?? 0;
        const petShopRecCount =
          getPetShopRecordBasedType(pay?.paymentDetails)?.length ?? 0;
        if ((clinicDet?.billingMode ?? "")?.toLowerCase() === "separate") {
          let parUrl = "";
          let petUrl = "";

          if (pharRecCount === 0) {
            parUrl = "pharmacyCheckout=Y";
          } else if (pay?.pharmacyCheckout === "Y") {
            parUrl = "pharmacyCheckout=N";
          }

          if (petShopRecCount === 0) {
            petUrl = "petShopCheckout=Y";
          } else if (pay?.petShopCheckout === "Y") {
            petUrl = "petShopCheckout=N";
          }

          const url = `${parUrl ? `?${parUrl}` : ""}${
            petUrl ? `${parUrl ? "&" : "?"}${petUrl}` : ""
          }`;

          if (url) {
            dispatch(
              enableCheckoutByAppointmentId({
                apntId: billDetails?.appointmentId ?? apnt?.appointmentId,
                paymentId: billDetails?.paymentId ?? bill?.paymentId,
                url,
              }),
            );
          }
        }
      }
      if (disValues?.type && Number(disValues?.amt) > 0) {
        if (disValues?.type?.toLowerCase() === "price") {
          discount = Number(disValues?.amt);
        }
        if (disValues?.type?.toLowerCase() === "percentage") {
          discount = (subTotal / 100) * Number(disValues?.amt);
        }
      }
      const reqData = {
        paymentId:
          location?.state?.bill?.paymentId ??
          pay?.paymentId ??
          petDet?.paymentId,
        data: {
          totalAmt: Number(subTotal ?? 0),
          amtPaid: Number(pay?.amtPaid ?? 0),
          discount: Number(discount ?? 0),
          tax: Number(tax ?? 0),
        },
      };

      dispatch(updateBillingByPaymentId(reqData))?.then((apiRes) => {
        if (apiRes?.payload) {
          dispatch(
            getBillDetailsByPaymentId(
              location?.state?.bill?.paymentId ??
                bill?.paymentId ??
                petDet?.paymentId,
            ),
          );
        }
      });
    });
  };

  const applyPriceDiscountToItems = (
    item = null,
    reqDiscountValue = 0,
    isUpdateItem = false,
  ) => {
    let reqArray = getTabBasedRecords() ?? [];
    if (!isUpdateItem) {
      reqArray.push({
        ...item,
        tax: 0,
        total:
          item?.servicePrice ??
          item?.unitSellingPrice ??
          item?.stockBatch?.[0]?.unitSellingPrice ??
          0,
        discount: 0,
        adminCharge: 0,
        quantity: 1,
        subTotal:
          item?.servicePrice ??
          item?.unitSellingPrice ??
          item?.stockBatch?.[0]?.unitSellingPrice ??
          0,
      });
    }
    if (isUpdateItem) {
      reqArray = reqArray?.map((li) => {
        if (li?.paymentDetailId === item?.paymentDetailId) {
          return {
            ...li,
            ...item,
            quantity: Number(itemValues?.quantity ?? 1),
            subTotal:
              Number(item?.mrpPrice ?? 0) * Number(itemValues?.quantity ?? 1),
            total:
              Number(item?.mrpPrice ?? 0) * Number(itemValues?.quantity ?? 1),
            discount: 0,
          };
        }
        return {
          ...li,
          subTotal: Number(li?.mrpPrice ?? 0) * Number(li?.quantity ?? 1),
          total: Number(li?.mrpPrice ?? 0) * Number(li?.quantity ?? 1),
          discount: 0,
        };
      });
    }
    const totalDet = getTaxAndSubTotalAndTotal(reqArray);

    const applyDiscount = reqArray?.map((li) => {
      const reqObj = {
        paymentDetailsId: li?.paymentDetailId ?? null,
        discount: 0,
        percentage: "pr",
        price: 0,
        mrpPrice: 0,
        mrpDiscount: 0,
        tax: 0,
        total: 0,
        quantity: li?.quantity,
      };
      const reqStck = stocks?.data?.find((stc) => stc?.stockId === li?.stockId);
      const reqBat = reqStck?.stockBatch?.find(
        (btch) => btch?.batchId === li?.batchId,
      );
      if (reqBat) {
        if (activeTab === "Treatment") {
          const unitPrice = Number(reqBat?.unitSellingPrice);
          const discount = Number(
            Number(
              Number(
                Number(unitPrice) /
                  Number(
                    totalDet?.subTotal - totalDet?.tax + totalDet?.discount,
                  ),
              ) * Number(reqDiscountValue ?? 0),
            ),
          );
          const priceAfterDiscount = Number(unitPrice) - Number(discount);
          reqObj.price = unitPrice;
          reqObj.discount = discount;
          reqObj.mrpPrice = unitPrice;
          reqObj.mrpDiscount = discount;
          reqObj.total =
            Number(
              Number(priceAfterDiscount) +
                Number(reqBat?.administeringCharges ?? 0),
            ) * Number(li?.quantity);
        }
        if (activeTab === "Pharmacy") {
          const taxPerent =
            clinicDet?.pharmacyTaxId?.length > 0
              ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
              : 0;
          const reqPercent = 100 + Number(taxPerent);
          const unitPrice =
            Number(reqBat?.unitSellingPrice) / (reqPercent / 100);
          const discount = Number(
            Number(
              Number(
                Number(unitPrice) /
                  Number(
                    totalDet?.subTotal - totalDet?.tax + totalDet?.discount,
                  ),
              ) * Number(reqDiscountValue ?? 0),
            ),
          );
          const priceAfterDiscount = Number(unitPrice) - Number(discount);
          const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
          reqObj.price = unitPrice;
          reqObj.discount = discount;
          reqObj.tax = Number(taxValue ?? 0) * Number(li?.quantity);
          reqObj.total =
            Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
            Number(li?.quantity);
          reqObj.mrpPrice = Number(reqBat?.unitSellingPrice);
          reqObj.mrpDiscount = discount;
        }
      }
      if (li?.serviceId) {
        const unitPrice =
          (li?.variantId
            ? services?.data
                ?.find((ser) => ser?.serviceId === li?.serviceId)
                ?.serviceVariants?.find((sv) => sv?.variantId === li?.variantId)
            : services?.data?.find((ser) => ser?.serviceId === li?.serviceId)
          )?.servicePrice ??
          item?.servicePrice ??
          0;

        const discount = Number(
          Number(
            Number(
              Number(unitPrice) /
                Number(totalDet?.subTotal - totalDet?.tax + totalDet?.discount),
            ) * Number(reqDiscountValue ?? 0),
          ),
        );
        reqObj.price = Number(unitPrice ?? 0);
        reqObj.discount = discount;
        reqObj.total =
          (Number(unitPrice ?? 0) - Number(discount ?? 0)) *
          Number(li?.quantity);
        reqObj.mrpPrice = Number(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      if (!li?.serviceId && !li?.stockId) {
        const unitPrice = li?.price;
        const discount = Number(
          Number(
            Number(
              Number(
                Number(unitPrice) /
                  Number(
                    totalDet?.subTotal - totalDet?.tax + totalDet?.discount,
                  ),
              ) * Number(reqDiscountValue ?? 0),
            ),
          ),
        );
        reqObj.price = Number(unitPrice ?? 0);
        reqObj.tax = 0;
        reqObj.discount = discount;
        reqObj.total =
          (Number(unitPrice ?? 0) - Number(discount ?? 0)) *
          Number(li?.quantity);
        reqObj.mrpPrice = Number(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      return reqObj;
    });

    const getNewObj = applyDiscount?.find(
      (li) =>
        !li?.paymentDetailsId || li?.paymentDetailsId === item?.paymentDetailId,
    );
    const paymentServiceRequest = {
      paymentDetailId: item?.paymentDetailId ?? null,
      billType: activeTab === "Treatment" ? "administered" : "prescribed",
      adminCharge: "N",
      adminChargeAmount: 0,
      name: item?.name ?? searchValue,
      quantity: Number(itemValues?.quantity ?? 1),
      type: item ? (item?.serviceId ? "service" : "product") : "service",
      discount: getNewObj?.discount ?? 0,
      mrpDiscount: getNewObj?.mrpDiscount ?? 0,
      percentage: false,
      subUnit: "Unit",
      price: getNewObj?.price ?? 0,
      mrpPrice: getNewObj?.mrpPrice ?? 0,
      tax: getNewObj?.tax ?? 0,
      discountType: "pr",
      total: getNewObj?.total ?? 0,
    };
    if (item?.productId) paymentServiceRequest.productId = item?.productId;
    if (item?.serviceId) paymentServiceRequest.serviceId = item?.serviceId;
    if (item?.variantNumber)
      paymentServiceRequest.variantNumber = item?.variantNumber;
    if (item?.variantId) paymentServiceRequest.variantId = item?.variantId;
    const data = {
      applyDiscount: applyDiscount?.filter((li) => li?.paymentDetailsId),
      treatmentDiscountType: "pr",
      treatmentDiscountValue:
        activeTab === "Treatment"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.treatmentDiscountValue ?? 0),
      treatmentDiscountId: billDetails?.treatmentDiscountId ?? [],
      pharmacyDiscountType: "pr",
      pharmacyDiscountValue:
        activeTab === "Pharmacy"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.pharmacyDiscountValue ?? 0),
      pharmacyDiscountId: billDetails?.pharmacyDiscountId ?? [],
      petShopDiscountType: "pr",
      petShopDiscountValue:
        activeTab === "Pet Shop"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.petShopDiscountValue ?? 0),
      petShopDiscountId: billDetails?.petShopDiscountId ?? [],
    };
    if (!isUpdateItem) data.paymentServiceRequest = paymentServiceRequest;
    dispatch(
      applyTotalDiscountByPayAndDetailId({
        paymentId:
          bill?.paymentId ?? billDetails?.paymentId ?? petDet?.paymentId,
        data,
      }),
    ).then((res) => {
      if (res?.payload) {
        setSelectedItem(null);
        setEditVisible(false);
        setSearchValue("");
        setSearchVisible(false);
        dispatch(
          getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId),
        );
      }
    });
  };

  const handleAddItem = async (item) => {
    const prevDiscountList = getUsedDiscountCodes();
    let discountType = "percentage",
      discountValue = 0;
    if (prevDiscountList?.length > 0) {
      const reqObj = getPrevDiscountValues(prevDiscountList);
      if (reqObj?.percentage > 0) {
        discountType = "percentage";
        discountValue = reqObj?.percentage;
      }
      if (reqObj?.price > 0) {
        discountType = "price";
        discountValue = reqObj?.price;
      }
    }
    if (
      discountType?.toLowerCase() !== "percentage" &&
      getTabBasedRecords()?.length > 0
    ) {
      return applyPriceDiscountToItems(item, discountValue);
    }
    const reqObj = {
      billType:
        activeTab === "Treatment"
          ? "administered"
          : activeTab === "Pet Shop"
            ? "petshop"
            : "prescribed",
      adminCharge: "N",
      adminChargeAmount: 0,
      name: item?.name ?? searchValue,
      quantity: 1,
      type: item ? (item?.serviceId ? "service" : "product") : "service",
      discount: 0,
      percentage: false,
      subUnit: "Unit",
      patientWorkbook: false,
    };
    if (item?.serviceId) {
      let serviceTax = 0,
        serviceTotal = 0,
        subItemTax = 0;
      const reqService = services?.data?.find(
        (ser) => ser?.serviceId === item?.serviceId,
      );
      const reqVariant = reqService?.serviceVariants?.find(
        (vnt) => vnt?.variantId === item?.variantId,
      );
      serviceTotal += Number(reqVariant?.serviceCharge ?? 0);
      if (reqService?.taxApplicability?.toLowerCase() === "yes") {
        serviceTax +=
          reqService?.taxApplicability?.toLowerCase() === "yes"
            ? (Number(reqVariant?.serviceCharge ?? 0) / 100) *
              Number(reqService?.tax ?? 0)
            : 0;
      }
      // const serviceAdminList =
      //   reqVariant?.servicePrescreiptions?.filter(
      //     (sp) => sp?.administered?.toLowerCase() === "administered"
      //   ) ?? [];
      // if (reqVariant?.serviceDetails?.length > 0) {
      //   reqVariant?.serviceDetails?.forEach((sd) => {
      //     const reqStck = stocks?.data?.find(
      //       (stc) => stc?.stockId === sd?.stockId
      //     );
      //     const reqBat = reqStck?.stockBatch?.find(
      //       (btch) => btch?.batchId === sd?.batchId
      //     );
      //     // const reqDiscount =
      //     //   discountType?.toLowerCase() !== "percentage"
      //     //     ? Number(discountValue ?? 0)
      //     //     : Number(
      //     //         Number(Number(reqBat?.unitSellingPrice ?? 0) / 100) *
      //     //           Number(discountValue ?? 0)
      //     //       ) ?? 0;
      //     const taxPerent =
      //       reqService?.taxApplicability?.toLowerCase() === "yes"
      //         ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
      //         : 0;
      //     const reqPercent = 100 + Number(taxPerent);
      //     const unitPrice =
      //       Number(reqBat?.unitSellingPrice) / (reqPercent / 100);
      //     const priceAfterDiscount = Number(unitPrice);
      //     const prdTaxValue = (taxPerent / 100) * Number(priceAfterDiscount);
      //     //  - Number(reqDiscount);
      //     subItemTax += Number(sd?.quantity ?? 1) * Number(prdTaxValue);
      //     serviceTotal +=
      //       Number(reqBat?.unitSellingPrice) * Number(sd?.quantity ?? 1);
      //   });
      // }
      // if (serviceAdminList?.length > 0) {
      //   serviceAdminList?.forEach((sd) => {
      //     const reqStck = stocks?.data?.find(
      //       (stc) => stc?.stockId === sd?.stockId
      //     );
      //     const reqBat = reqStck?.stockBatch?.find(
      //       (btch) => btch?.batchId === sd?.batchId
      //     );
      //     // const reqDiscount =
      //     //   discountType?.toLowerCase() !== "percentage"
      //     //     ? Number(discountValue ?? 0)
      //     //     : Number(
      //     //         Number(Number(reqBat?.unitSellingPrice ?? 0) / 100) *
      //     //           Number(discountValue ?? 0)
      //     //       ) ?? 0;
      //     const taxPerent =
      //       reqService?.taxApplicability?.toLowerCase() === "yes"
      //         ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
      //         : 0;
      //     const reqPercent = 100 + Number(taxPerent);
      //     const unitPrice =
      //       Number(reqBat?.unitSellingPrice) / (reqPercent / 100);
      //     const priceAfterDiscount = Number(unitPrice);
      //     const prdTaxValue = (taxPerent / 100) * Number(priceAfterDiscount);
      //     //  - Number(reqDiscount);
      //     subItemTax += Number(sd?.dosage ?? 1) * Number(prdTaxValue);
      //     serviceTotal +=
      //       Number(reqBat?.unitSellingPrice) * Number(sd?.dosage ?? 1);
      //   });
      // }
      const reqDiscount =
        discountType?.toLowerCase() !== "percentage"
          ? Number(discountValue ?? 0)
          : (Number(
              Number(Number(item?.servicePrice ?? 0) / 100) *
                Number(discountValue ?? 0),
            ) ?? 0);
      reqObj.serviceId = item?.serviceId;
      reqObj.variantId = item?.variantId;
      reqObj.variantNumber = item?.variantNumber;
      reqObj.price = Number(reqVariant?.serviceCharge ?? 0);
      reqObj.mrpPrice = Number(reqVariant?.serviceCharge ?? 0);
      reqObj.discountType =
        discountType?.toLowerCase() === "percentage" ? "pe" : "pr";
      reqObj.discount = reqDiscount;
      reqObj.mrpDiscount =
        discountType?.toLowerCase() !== "percentage"
          ? (Number(itemValues?.servicePrice ?? 0) / 100) *
            Number(reqDiscount ?? 0)
          : Number(reqDiscount ?? 0);
      reqObj.tax = Number(serviceTax) + Number(subItemTax);
      reqObj.total = Number(serviceTotal ?? 0) + Number(serviceTax ?? 0);
      reqObj.hsnSacCode = item?.hsnSacCode ?? null;
    }
    if (item?.stockId) {
      const reqBat = item?.stockBatch?.[0];
      reqObj.stockId = item?.stockId;
      if (activeTab === "Treatment") {
        const treatList = getTreatmentRecordBasedType(
          billDetails?.paymentDetails ?? [],
        );
        const stockAvailInPatWorkbook = treatList?.some(
          (li) => li?.stockId === item?.stockId,
        );
        reqObj.patientWorkbook = stockAvailInPatWorkbook;
      }
      if (reqBat) {
        reqObj.batchId = reqBat?.batchId;

        const reqDiscount =
          discountType?.toLowerCase() !== "percentage"
            ? Number(discountValue ?? 0)
            : (Number(
                Number(Number(reqBat?.unitSellingPrice ?? 0) / 100) *
                  Number(discountValue ?? 0),
              ) ?? 0);
        const taxPerent =
          (activeTab === "Pharmacy"
            ? clinicDet?.pharmacyTaxId
            : activeTab === "Treatment"
              ? clinicDet?.taxId
              : clinicDet?.petShopTaxId
          )?.length > 0
            ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
            : 0;
        const reqPercent = 100 + Number(taxPerent);
        const reqPack = reqBat?.packageUom?.match(/^(\d+)(.+)/);
        const priceRatio =
          Number(itemValues?.quantity ?? 1) / Number(reqPack?.[1] ?? 1);
        const reqPrice =
          (Number(reqBat?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
        const reqUnitPrice =
          activeTab === "Treatment" ? reqPrice : reqBat?.unitSellingPrice;
        const unitPrice = Number(reqUnitPrice) / (reqPercent / 100);
        const priceAfterDiscount = Number(unitPrice) - Number(reqDiscount);
        const prdTaxValue = (taxPerent / 100) * Number(unitPrice);
        reqObj.price = unitPrice;
        reqObj.discount = reqDiscount;
        reqObj.tax = Number(prdTaxValue);
        reqObj.total = Number(
          Number(priceAfterDiscount ?? 0) + Number(prdTaxValue ?? 0),
        );
        reqObj.mrpPrice = Number(reqBat?.unitSellingPrice);
        reqObj.mrpDiscount =
          discountType?.toLowerCase() === "percentage"
            ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
            : Number(discountValue ?? 0);
        reqObj.hsnSacCode = item?.hsnSacCode ?? null;
        reqObj.drugSchedule = item?.drugSchedule ?? null;
        reqObj.packageUom = reqBat?.packageUom ?? null;
        reqObj.expiryDate = reqBat?.expiryDate ?? null;
        reqObj.batchNo = reqBat?.batchNo ?? null;
      }
    }
    if (!item) {
      reqObj.price = 0;
      reqObj.tax = 0;
      reqObj.total = 0;
    }
    const reqData = {
      paymentId:
        location?.state?.bill?.paymentId ??
        bill?.paymentId ??
        petDet?.paymentId,
      data: reqObj,
    };
    dispatch(addBillingItemsByPaymentId(reqData))?.then((res) => {
      if (res?.payload) {
        handleUpdatePaymentValues();
        setSearchValue("");
        setSearchVisible(false);
      }
    });
  };

  const handleUpdateItem = async (item) => {
    if (getTaxDiscountAndTotal(itemValues)?.isHigherDiscount) return;
    // const prevDiscountList = getUsedDiscountCodes();
    let discountType = "percentage",
      discountValue = 0;
    if (typeof item?.discountValue === "object") {
      discountType = item?.discountValue?.discountType?.toLowerCase();
      discountValue = item?.discountValue?.discountValue;
    }
    if (typeof item?.discountValue !== "object") {
      discountType = item?.discountType?.value?.toLowerCase();
      discountValue = item?.discountValue;
    }

    // if (prevDiscountList?.length > 0) {
    //   const reqObj = getPrevDiscountValues(prevDiscountList);
    //   if (reqObj?.percentage > 0) {
    //     discountType = "percentage";
    //     discountValue = reqObj?.percentage;
    //   }
    //   if (reqObj?.price > 0) {
    //     discountType = "price";
    //     discountValue = reqObj?.price;
    //   }
    // }
    // if (
    //   discountType?.toLowerCase() !== "percentage" &&
    //   (activeTab === "Treatment"
    //     ? getTreatmentRecordBasedType(billDetails?.paymentDetails)
    //     : getPharmacyRecordBasedType(billDetails?.paymentDetails)
    //   )?.length > 0
    // ) {
    //   return applyPriceDiscountToItems(item, discountValue, true);
    // }
    const reqStck = stocks?.data?.find(
      (stc) => stc?.stockId === (itemValues?.stockId ?? item?.stockId),
    );
    const reqBat = reqStck?.stockBatch?.find(
      (btch) =>
        btch?.batchId ===
        (item?.batchNumber?.batchId ??
          item?.batchNumber?.value ??
          item?.batchId),
    );
    let discount =
      discountType?.toLowerCase() !== "percentage"
        ? Number(discountValue ?? 0)
        : (Number(
            Number(Number(itemValues?.price ?? 0) / 100) *
              Number(discountValue ?? 0),
          ) ?? 0);
    const reqObj = {
      paymentDetaisId: selectedItem?.paymentDetailId ?? item?.paymentDetailId,
      tax: 0,
      adminCharge: "N",
      adminChargeAmount: 0,
      quantity: Number(itemValues?.quantity),
      type: selectedItem?.type ?? item?.type,
      percentage: discountType?.toLowerCase() === "percentage",
      stockId: itemValues?.stockId,
      batchId:
        item?.batchNumber?.batchId ?? item?.batchNumber?.value ?? item?.batchId,
      name: itemValues?.name,
      billType:
        activeTab === "Treatment"
          ? "administered"
          : activeTab === "Pet Shop"
            ? "petshop"
            : "prescribed",
      serviceId: item?.serviceId,
      patientWorkbook: item?.patientWorkbook ?? false,
      total: Number(item?.total ?? 0),
      mrpPrice: Number(itemValues?.mrpPrice ?? 0),
    };
    if (activeTab === "Treatment") {
      reqObj.procedureId = itemValues?.linkToProcedure?.apiValue ?? null;
    }
    if (reqBat) {
      const taxPerent =
        (activeTab === "Pharmacy"
          ? clinicDet?.pharmacyTaxId
          : activeTab === "Treatment"
            ? clinicDet?.taxId
            : clinicDet?.petShopTaxId
        )?.length > 0
          ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
          : 0;
      const reqPercent = 100 + Number(taxPerent);
      const reqPack = reqBat?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio =
        Number(itemValues?.quantity ?? 1) / Number(reqPack?.[1] ?? 1);
      const reqPrice =
        (Number(reqBat?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      const reqUnitPrice =
        activeTab === "Treatment" ? reqPrice : reqBat?.unitSellingPrice;
      const unitPrice = Number(reqUnitPrice) / (reqPercent / 100);
      const reqDiscount =
        discountType?.toLowerCase() === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
      const priceAfterDiscount = Number(unitPrice) - Number(reqDiscount ?? 0);
      const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
      reqObj.price = Number(reqBat?.unitSellingPrice);
      reqObj.discount = Number(reqDiscount ?? 0);
      reqObj.tax =
        Number(taxValue ?? 0) *
        Number(activeTab === "Treatment" ? 1 : itemValues?.quantity);
      reqObj.total =
        Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
        Number(activeTab === "Treatment" ? 1 : itemValues?.quantity);
      reqObj.mrpPrice = Number(reqBat?.unitSellingPrice);
      reqObj.mrpDiscount = Number(reqDiscount ?? 0);
      reqObj.hsnSacCode = itemValues?.hsnSacCode ?? null;
      reqObj.drugSchedule = itemValues?.drugSchedule ?? null;
      reqObj.packageUom = reqBat?.packageUom ?? null;
      reqObj.expiryDate = reqBat?.expiryDate ?? null;
      reqObj.batchNo = reqBat?.batchNo ?? null;
      // }
    }
    if (!item?.serviceId && !item?.stockId) {
      reqObj.price = Number(itemValues?.price ?? 0);
      reqObj.tax = 0;
      reqObj.discount = discount;
      reqObj.total =
        (Number(itemValues?.price ?? 0) - Number(discount ?? 0)) *
        Number(itemValues?.quantity);
      reqObj.mrpPrice = Number(itemValues?.price ?? 0);
      reqObj.mrpDiscount =
        discountType?.toLowerCase() === "percentage"
          ? (Number(itemValues?.price ?? 0) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
    }
    if (item?.serviceId) {
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === item?.serviceId,
      );
      const reqVar = reqServ?.serviceVariants?.find(
        (vnt) => vnt?.variantId === item?.variantId,
      );
      const unitPrice =
        Number(itemValues?.price ?? 0) ?? Number(reqVar?.serviceCharge ?? 0);
      const taxPerent =
        reqServ?.taxApplicability?.toLowerCase() === "yes"
          ? Number(reqServ?.tax ?? 0)
          : 0;
      const reqDiscount =
        discountType?.toLowerCase() === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
      const priceAfterDiscount = Number(unitPrice) - Number(reqDiscount ?? 0);
      const taxValue =
        (Number(priceAfterDiscount ?? 0) / 100) * Number(taxPerent ?? 0);
      const priceAfterTax = Number(priceAfterDiscount) + Number(taxValue);
      reqObj.price = unitPrice;
      reqObj.mrpPrice = unitPrice;
      reqObj.mrpDiscount = Number(reqDiscount ?? 0);
      reqObj.discount = Number(reqDiscount ?? 0);
      reqObj.variantId = itemValues?.variantId;
      reqObj.variantNumber = itemValues?.variantNumber;
      reqObj.tax = Number(taxValue ?? 0) * Number(itemValues?.quantity ?? 1);
      reqObj.total =
        Number(priceAfterTax ?? 0) * Number(itemValues?.quantity ?? 1);
      reqObj.hsnSacCode = itemValues?.hsnSacCode ?? null;
    }
    const reqData = {
      paymentId:
        location?.state?.bill?.paymentId ??
        bill?.paymentId ??
        petDet?.paymentId,
      data: reqObj,
    };
    dispatch(updateBillingItemsByPaymentId(reqData)).then((res) => {
      if (res?.payload) {
        handleUpdatePaymentValues();
        setSelectedItem(null);
        setEditVisible(false);
        setEditModVsble(false);
      }
    });
  };

  const handleClosePrintModal = () => {
    setPrntPrevVsble(false);
  };

  const finalPayment = () => {
    //validation start
    let errs = {};
    if (
      !payValues?.amount ||
      isNaN(Number(payValues?.amount)) ||
      Number(payValues?.amount) <= 0 ||
      Number(payValues?.amount) > totalBalanceDue ||
      (payValues?.paymentMode?.value === "advanceAdjustment" &&
        Number(payValues?.amount) > Number(billDetails?.advanceAmount))
    ) {
      errs = {
        ...errs,
        amount:
          payValues?.paymentMode?.value === "advanceAdjustment" &&
          Number(payValues?.amount) > Number(billDetails?.advanceAmount)
            ? "Insufficient credit balance"
            : !payValues?.amount
              ? "This field is required"
              : Number(payValues?.amount) > totalBalanceDue
                ? "Amount must be less than or equal to balance due"
                : Number(payValues?.amount) <= 0
                  ? "Amount must be positive"
                  : "",
      };
    }
    if (!payValues?.paymentMode?.value) {
      errs = { ...errs, paymentMode: "This field is required" };
    }
    if (Object.values(errs).some((item) => item?.length > 0)) {
      return setPayErr(errs);
    }
    //validation end here
    const data = {
      paymentId: billDetails?.paymentId,
      paymentMode: payValues?.paymentMode?.value,
      paymentAmount: Number(payValues?.amount),
    };
    dispatch(updatePayment(data)).then(async (res) => {
      if (res?.payload) {
        if (bill?.paymentId ?? petDet?.paymentId) {
          dispatch(
            getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId),
          );
        }
        setPayModalVisible(false);
        setPayValues(initialPayValues);
        setTotalBalanceDue(0);
        setPayErr({});
      }
    });
  };

  const payModClose = () => {
    setPayValues(initialPayValues);
    setPayModalVisible(false);
    setPayErr({});
  };

  const handleChangeValues = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    setPayValues({ ...payValues, [name]: value });
    const errObj = {
      ...payErr,
      [name]: reqValue?.length > 0 ? "" : "This field is required",
    };
    if (name === "paymentMode") {
      if (reqValue !== "advanceAdjustment") {
        errObj.amount = "";
      }
      if (reqValue === "advanceAdjustment") {
        if (Number(billDetails?.advanceAmount ?? 0) <= 0) {
          errObj.amount = "Insufficient credit balance";
        }
      }
    }
    if (name === "amount") {
      if (payValues?.paymentMode?.value === "advanceAdjustment") {
        errObj.amount =
          Number(value) < 0
            ? "Amount must be positive"
            : Number(value) > Number(billDetails?.advanceAmount)
              ? "Insufficient credit balance"
              : "";
      } else {
        errObj.amount = Number(value) < 0 ? "Amount must be positive" : "";
      }
      if (Number(value) > totalBalanceDue) {
        errObj.amount = "Amount must be less than or equal to balance due";
      }
    }
    setPayErr(errObj);
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    const filteredBatches = reqStock?.stockBatch?.map((btch) => ({
      name: btch?.batchNo,
      value: btch?.batchNo,
      batchId: btch?.batchId,
    }));
    return filteredBatches;
  };

  const handleApplyDiscount = () => {
    const reqObj = { ...disValues };
    if (activeTab === "Treatment") {
      reqObj.type =
        Number(billDetails?.treatmentDiscountValue ?? 0) > 0
          ? billDetails?.treatmentDiscountType === "pe"
            ? "percentage"
            : "price"
          : "code";
      reqObj.amt = billDetails?.treatmentDiscountValue ?? 0;
      reqObj.discountCode = null;
    }
    if (activeTab === "Pharmacy") {
      reqObj.type =
        Number(billDetails?.pharmacyDiscountValue ?? 0) > 0
          ? billDetails?.pharmacyDiscountType === "pe"
            ? "percentage"
            : "price"
          : "code";
      reqObj.amt = billDetails?.pharmacyDiscountValue ?? 0;
      reqObj.discountCode = null;
    }
    if (activeTab === "Pet Shop") {
      reqObj.type =
        Number(billDetails?.petShopDiscountValue ?? 0) > 0
          ? billDetails?.petShopDiscountType === "pe"
            ? "percentage"
            : "price"
          : "code";
      reqObj.amt = billDetails?.petShopDiscountValue ?? 0;
      reqObj.discountCode = null;
    }
    setDisValues(reqObj);
    setDisModVsble(true);
  };

  const onGenerateBill = () => {
    if (!billedByValues?.billedBy?.value) {
      setBilledByValues({ ...billedByValues, error: true });
      return;
    }
    const billedByUrl = `&billedById=${billedByValues?.billedBy?.value}&billedByName=${billedByValues?.billedBy?.name}`;
    let url = `?checkout=true&petShopCheckout=Y&pharmacyCheckout=Y${billedByUrl}`;
    if ((clinicDet?.billingMode ?? "")?.toLowerCase() === "separate") {
      if (activeTab === "Treatment") {
        url = `?checkout=true${billedByUrl}`;
      }
      if (activeTab === "Pharmacy") {
        url = `?pharmacyCheckout=Y${billedByUrl}`;
      }
      if (activeTab === "Pet Shop") {
        url = `?petShopCheckout=Y${billedByUrl}`;
      }
      // url = `?checkout=${activeTab === "Treatment" ? true : billDetails?.checkOut === "Y"}&pharmacyCheckout=${activeTab === "Pharmacy" ? "Y" : (billDetails?.pharmacyCheckout ?? "N")}&petShopCheckout=${activeTab === "Pet Shop" ? "Y" : (billDetails?.petShopCheckout ?? "N")}${billedByUrl}`;
    }
    dispatch(
      enableCheckoutByAppointmentId({
        apntId: billDetails?.appointmentId ?? apnt?.appointmentId,
        paymentId: billDetails?.paymentId ?? bill?.paymentId,
        url,
      }),
    ).then((res) => {
      if (res?.payload) {
        setItemValues(initialValues);
        dispatch(
          getBillDetailsByPaymentId(
            location?.state?.bill?.paymentId ??
              bill?.paymentId ??
              petDet?.paymentId,
          ),
        );
        dispatch(getPetsCompliantSummary(apnt?.appointmentId));
      }
    });
  };

  const onChangeShowValue = (name, value) => {
    const reqObj = { ...showValues, [name]: value };
    if (name === "showSublinePrice" && value) {
      reqObj.showSublineItems = true;
    }
    if (name === "showSublineItems" && !value) {
      reqObj.showSublinePrice = false;
    }
    setShowValues(reqObj);
    dispatch(
      updateBillCheckDetails({
        paymentId: bill?.paymentId ?? petDet?.paymentId,
        showSublineItems: reqObj?.showSublineItems,
        showSublinePrice: reqObj?.showSublinePrice,
      }),
    ).then((res) => {
      if (res?.payload) {
        dispatch(
          getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId),
        );
      }
    });
  };

  const getIsLocationMatch = (batchList = [], category = "pharmacy") => {
    const result = batchList?.some((bat) => {
      if (!bat?.locationId) return false;
      const loc = locationList?.find((loc) => loc?.id === bat?.locationId);
      return loc && loc?.category?.toLowerCase() === category;
    });
    return result;
  };

  const getFilteredList = () => {
    if (!searchVisible) return [];
    if (searchValue?.length > 0) {
      const reqPrdList = stocks?.data?.map((li) => ({
        ...li,
        name: li?.productName,
        type: "Product",
      }));
      let reqList = activeTab === "Treatment" ? [] : (reqPrdList ?? []);
      if (activeTab === "Treatment") {
        const reqServList = [];
        serviceList?.forEach((ser) => {
          if (ser?.serviceVariants?.length > 0) {
            ser?.serviceVariants?.forEach((vrnt) => {
              const reqObj = {
                name: `${ser?.serviceName} (${vrnt?.variantName})`,
                variantId: vrnt?.variantId,
                variantNumber: vrnt?.variantNumber,
                type: "Service",
                category: ser?.category,
                servicePrice: vrnt?.serviceCharge ?? 0,
                serviceId: ser?.serviceId,
                hsnSacCode: ser?.hsnSacCode ?? null,
              };
              reqServList.push(reqObj);
            });
          } else {
            reqServList.push(ser);
          }
        });
        reqList = [...(reqServList ?? []), ...(reqPrdList ?? [])] ?? [];
      }
      const filList = reqList?.filter(
        (sp) =>
          (sp?.stockId
            ? sp?.active === "Y" && sp?.billable
              ? activeTab === "Pharmacy"
                ? posPharmacyCategoryList?.includes(
                    sp?.category?.toLowerCase(),
                  ) && getIsLocationMatch(sp?.stockBatch, "pharmacy")
                : activeTab === "Pet Shop"
                  ? posPetShopCategoryList?.includes(
                      sp?.category?.toLowerCase(),
                    ) && getIsLocationMatch(sp?.stockBatch, "pet shop")
                  : apnt?.inpatient ||
                      apnt?.appointmentType?.toLowerCase() === "physical"
                    ? billingPharmacyCategoryList?.includes(
                        sp?.category?.toLowerCase(),
                      ) &&
                      (getIsLocationMatch(sp?.stockBatch, "pharmacy") ||
                        getIsLocationMatch(sp?.stockBatch, "clinic"))
                    : apnt?.appointmentType?.toLowerCase() === "home"
                      ? billingPharmacyCategoryList?.includes(
                          sp?.category?.toLowerCase(),
                        ) && getIsLocationMatch(sp?.stockBatch, "at-home")
                      : []
              : false
            : true) &&
          (sp?.name?.toLowerCase().includes(searchValue?.toLowerCase()) ||
            sp?.tradeName?.toLowerCase().includes(searchValue?.toLowerCase()) ||
            sp?.productName
              ?.toLowerCase()
              .includes(searchValue?.toLowerCase())),
      );

      return filList;
    }
  };

  const onCloseEditMod = () => {
    setEditModVsble(false);
    setItemValues(null);
    setSelectedItem(null);
  };

  const reqFacility = () => {
    return (
      facilities?.find((fac) => fac?.facilityId === apnt?.facilityId) ?? null
    );
  };

  const getBatch = (stkId = null, batchId = null) => {
    if (!stkId || !batchId) return null;
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stkId);
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const getBatches = (stkId = null) => {
    if (!stkId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stkId);
    return reqStock?.stockBatch
      ?.filter((bat) =>
        role === "ROLE_DOCTOR"
          ? bat?.locationId === reqFacility()?.primaryStorage ||
            bat?.locationId === reqFacility()?.secondaryStorage
          : true,
      )
      ?.map((bat) => {
        const reqLocation = locationList?.find(
          (loc) => loc?.id === bat?.locationId,
        );
        return {
          name: bat?.batchNo,
          value: bat?.batchId,
          subunits: bat?.subunits,
          quantity: bat?.quantity,
          locationId: bat?.locationId,
          locationName: reqLocation?.locationName ?? "",
          batchId: bat?.batchId,
        };
      });
  };

  const getTaxDiscountAndTotal = (itm) => {
    let tax = 0,
      discount = 0,
      total = 0,
      price = 0,
      discountType = "percentage",
      discountValue = 0,
      quantity = Number(itm?.quantity ?? 1),
      isHigherDiscount = false;

    // Extract discount type and value
    if (typeof itm?.discountValue === "object") {
      discountType = itm?.discountValue?.discountType?.toLowerCase();
      discountValue = Number(itm?.discountValue?.discountValue ?? 0);
    } else {
      discountType = itm?.discountType?.value?.toLowerCase() || "percentage";
      discountValue = Number(itm?.discountValue ?? 0);
    }
    // Handle stock items (products)
    if (itm?.stockId) {
      const reqStockBatch = stocks?.data?.find(
        (stc) => stc?.stockId === itm?.stockId,
      )?.stockBatch;
      const reqBat =
        (itm?.batchNumber?.batchId ?? itm?.batchId)
          ? reqStockBatch?.find(
              (bat) =>
                bat?.batchId === (itm?.batchNumber?.batchId ?? itm?.batchId),
            )
          : reqStockBatch?.[0];
      if (reqBat) {
        const unitPrice = Number(reqBat?.unitSellingPrice ?? 0);
        const taxPercent =
          (activeTab === "Pharmacy"
            ? clinicDet?.pharmacyTaxId
            : activeTab === "Treatment"
              ? clinicDet?.taxId
              : clinicDet?.petShopTaxId
          )?.length > 0
            ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
            : 0;
        const reqPack = reqBat?.packageUom?.match(/^(\d+)(.+)/);
        const reqPrice = (Number(unitPrice) ?? 0) / Number(reqPack?.[1] ?? 1);
        const reqUnitPrice =
          activeTab === "Treatment" ? reqPrice : reqBat?.unitSellingPrice;
        const reqPercent = 100 + Number(taxPercent);
        const unitPriceExcludingTax = Number(reqUnitPrice) / (reqPercent / 100);
        const calculatedDiscount =
          discountType === "percentage"
            ? (Number(unitPriceExcludingTax) / 100) * Number(discountValue ?? 0)
            : Number(discountValue ?? 0);
        const priceAfterDiscount =
          Number(unitPriceExcludingTax) - Number(calculatedDiscount);
        const taxValue = (taxPercent / 100) * Number(priceAfterDiscount);
        price = unitPriceExcludingTax;
        discount = Number(calculatedDiscount) * quantity;
        tax = Number(taxValue ?? 0) * quantity;
        total =
          Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
          quantity;
        // }
      }
    } else if (itm?.serviceId) {
      // Service items: with tax calculation
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === itm?.serviceId,
      );
      const reqVar = reqServ?.serviceVariants?.find(
        (vnt) => vnt?.variantId === itm?.variantId,
      );
      const unitPrice =
        Number(itm?.price ?? 0) ?? Number(reqVar?.serviceCharge ?? 0);
      const taxPercent =
        reqServ?.taxApplicability?.toLowerCase() === "yes"
          ? Number(reqServ?.tax ?? 0)
          : 0;
      const calculatedDiscount =
        discountType === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
      const priceAfterDiscount =
        Number(unitPrice) - Number(calculatedDiscount ?? 0);
      const taxValue =
        (Number(priceAfterDiscount ?? 0) / 100) * Number(taxPercent ?? 0);
      const priceAfterTax = Number(priceAfterDiscount) + Number(taxValue);
      price = unitPrice;
      discount = Number(calculatedDiscount) * quantity;
      tax = Number(taxValue ?? 0) * quantity;
      total = Number(priceAfterTax ?? 0) * quantity;
    } else {
      // Custom items (no stockId and no serviceId)
      price = Number(itm?.price ?? 0);
      const calculatedDiscount =
        discountType === "percentage"
          ? (Number(price) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);

      discount = Number(calculatedDiscount) * quantity;
      tax = 0;
      total = (Number(price) - Number(calculatedDiscount)) * quantity;
    }

    return { tax, discount, total, isHigherDiscount };
  };

  const isProcedurePresent = () => {
    const isProcedureAvail = getTreatmentRecordBasedType(
      billDetails?.paymentDetails ?? [],
    )?.some(
      (li) =>
        (li?.procedureId ?? "")?.toString()?.length > 0 &&
        li?.patientWorkbook &&
        !li?.procedureDetailId,
    );
    return activeTab === "Treatment" && isProcedureAvail && itemValues?.stockId;
  };

  const getProcedureList = () => {
    const reqList = getTreatmentRecordBasedType(
      billDetails?.paymentDetails ?? [],
    )
      ?.filter(
        (li) =>
          (li?.procedureId ?? "")?.toString()?.length > 0 &&
          li?.patientWorkbook &&
          !li?.procedureDetailId,
      )
      ?.map((li) => ({
        name: li?.name,
        value: li?.name,
        apiValue: li?.procedureId,
      }));
    return reqList;
  };

  const handlePay = () => {
    const dueAmount = Number(
      Number(
        roundWithSignedDiff(
          getTaxAndSubTotalAndTotalForTreatment(
            getTreatmentRecordBasedType(billDetails?.paymentDetails),
            services?.data,
            lastSummary?.procedures ?? [],
          )?.subTotal,
        )?.rounded +
          roundWithSignedDiff(
            getTaxAndSubTotalAndTotal(
              getPharmacyRecordBasedType(billDetails?.paymentDetails),
            )?.subTotal,
          )?.rounded +
          roundWithSignedDiff(
            getTaxAndSubTotalAndTotal(
              getPetShopRecordBasedType(billDetails?.paymentDetails),
            )?.subTotal,
          )?.rounded,
      ) - Number(billDetails?.amtPaid ?? 0),
    );
    setPayValues({ ...payValues, amount: dueAmount });
    setTotalBalanceDue(dueAmount);
    if (billDetails?.advanceAmount && Number(billDetails?.advanceAmount) <= 0) {
      const filtered = PaymentTypeList.filter(
        (list) => list?.value !== "advanceAdjustment",
      );
      setEnabledPaymentTypes(filtered);
    } else {
      setEnabledPaymentTypes(PaymentTypeList);
    }
    setPayModalVisible(true);
  };

  const getBilledByList = () => {
    const reqList = (clinicVets ?? [])
      ?.filter(
        (li) =>
          li?.userRole === "ROLE_ADMIN" ||
          li?.userRole === "ROLE_CLINICADMIN" ||
          li?.userRole === "ROLE_BILLING" ||
          li?.userRole === "ROLE_PHARMACY" ||
          li?.userRole === "ROLE_DOCTOR",
      )
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
    return reqList;
  };

  return (
    <div className="back-white w100Per">
      <div className="scroll-80vh ">
        <div className="light-blue-back3 br5 ph20 pv10">
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14 gray4">
              Amount Paid
            </Typography>
            <Typography className="green-color fs14 font-bold ml5">
              Rs{" "}
              {Number(billDetails?.amtPaid) > 0
                ? Number(billDetails?.amtPaid)?.toFixed(2)
                : Number(billDetails?.amtPaid)}
            </Typography>
            <Typography className="font-medium fs14 gray4 ml20">
              Balance Due
            </Typography>
            <Typography className="yellow-color fs14 font-bold ml5">
              Rs{" "}
              {Number(
                Number(
                  roundWithSignedDiff(
                    getTaxAndSubTotalAndTotalForTreatment(
                      getTreatmentRecordBasedType(billDetails?.paymentDetails),
                      services?.data,
                      lastSummary?.procedures ?? [],
                    )?.subTotal,
                  )?.rounded +
                    roundWithSignedDiff(
                      getTaxAndSubTotalAndTotal(
                        getPharmacyRecordBasedType(billDetails?.paymentDetails),
                      )?.subTotal,
                    )?.rounded +
                    roundWithSignedDiff(
                      getTaxAndSubTotalAndTotal(
                        getPetShopRecordBasedType(billDetails?.paymentDetails),
                      )?.subTotal,
                    )?.rounded,
                ) - Number(billDetails?.amtPaid ?? 0),
              )?.toFixed(2)}
            </Typography>
            <div className="flex1-end">
              <Typography className="font-medium fs14 gray4">
                Treatment
              </Typography>
              <Typography className="black fs14 font-bold ml5">
                Rs{" "}
                {Number(
                  Number(
                    roundWithSignedDiff(
                      getTaxAndSubTotalAndTotal(
                        getTreatmentRecordBasedType(
                          billDetails?.paymentDetails,
                        ),
                      )?.subTotal,
                    )?.rounded,
                  ),
                )?.toFixed(2)}
              </Typography>
              <Typography className="font-medium fs14 gray4 ml20">
                Pharmacy
              </Typography>
              <Typography className="black fs14 font-bold ml5">
                Rs{" "}
                {Number(
                  Number(
                    roundWithSignedDiff(
                      getTaxAndSubTotalAndTotal(
                        getPharmacyRecordBasedType(billDetails?.paymentDetails),
                      )?.subTotal,
                    )?.rounded,
                  ),
                )?.toFixed(2)}
              </Typography>
              <Typography className="font-medium fs14 gray4 ml20">
                Pet Shop
              </Typography>
              <Typography className="black fs14 font-bold ml5">
                Rs{" "}
                {Number(
                  Number(
                    roundWithSignedDiff(
                      getTaxAndSubTotalAndTotal(
                        getPetShopRecordBasedType(billDetails?.paymentDetails),
                      )?.subTotal,
                    )?.rounded,
                  ),
                )?.toFixed(2)}
              </Typography>
            </div>
          </div>
        </div>
        <div className="flex-row mv10">
          <Typography
            className={`ml20 newTab cursor ${activeTab === "Treatment" ? "newTabSelected" : ""}`}
            onClick={() => setActiveTab("Treatment")}
          >
            Treatment
          </Typography>
          <Typography
            className={`ml20 newTab cursor ${activeTab === "Pharmacy" ? "newTabSelected" : ""}`}
            onClick={() => setActiveTab("Pharmacy")}
          >
            Pharmacy
          </Typography>
          <Typography
            className={`ml20 newTab cursor ${activeTab === "Pet Shop" ? "newTabSelected" : ""}`}
            onClick={() => setActiveTab("Pet Shop")}
          >
            Pet Shop
          </Typography>
          <div className="flex1-end">
            <div className="flex-row-ali-cen pr20">
              {activeTab === "Treatment" && (
                <div className="flex1-end">
                  <div className="flex-row-ali-cen">
                    <CustomSwitch
                      value={showValues?.showSublineItems}
                      onChange={(e) =>
                        onChangeShowValue(
                          "showSublineItems",
                          !showValues?.showSublineItems,
                        )
                      }
                      grayToBlue
                    />
                    <Typography className="font-medium fs14 black ml10">
                      Show sub-line items
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen ml15">
                    <CustomSwitch
                      value={showValues?.showSublinePrice}
                      onChange={(e) =>
                        onChangeShowValue(
                          "showSublinePrice",
                          !showValues?.showSublinePrice,
                        )
                      }
                      grayToBlue
                    />
                    <Typography className="font-medium fs14 black ml10">
                      Show prices for the sub-line items
                    </Typography>
                  </div>
                </div>
              )}
              {billDetails?.checkOut !== "Y" &&
              billDetails?.appointmentStatus === "finalize" &&
              ((clinicDet?.billingMode ?? "")?.toLowerCase() === "combined"
                ? true
                : activeTab === "Treatment") ? (
                <div className="ml15">
                  <CustomButton
                    text="Generate Bill"
                    smallBtn
                    onClick={onGenerateBill}
                  />
                </div>
              ) : null}
              {billDetails?.pharmacyCheckout !== "Y" &&
              billDetails?.appointmentStatus === "finalize" &&
              ((clinicDet?.billingMode ?? "")?.toLowerCase() === "separate"
                ? activeTab === "Pharmacy" &&
                  getPharmacyRecordBasedType(billDetails?.paymentDetails)
                    ?.length > 0
                : false) ? (
                <div className="ml15">
                  <CustomButton
                    text="Generate Bill"
                    smallBtn
                    onClick={onGenerateBill}
                  />
                </div>
              ) : null}
              {billDetails?.petShopCheckout !== "Y" &&
              billDetails?.appointmentStatus === "finalize" &&
              ((clinicDet?.billingMode ?? "")?.toLowerCase() === "separate"
                ? activeTab === "Pet Shop" &&
                  getPetShopRecordBasedType(billDetails?.paymentDetails)
                    ?.length > 0
                : false) ? (
                <div className="ml15">
                  <CustomButton
                    text="Generate Bill"
                    smallBtn
                    onClick={onGenerateBill}
                  />
                </div>
              ) : null}
              <div
                className="cursor ml15"
                onClick={() => setPrntPrevVsble(true)}
              >
                <div className="flex-center">
                  <PrintIcon sx={w20h20BlueIcon} />
                </div>
                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                  Print
                </Typography>
              </div>
              {apnt?.checkOut === "Y" ? (
                <div className="cursor ml15" onClick={handlePay}>
                  <div className="flex-center">
                    <AccountBalanceWalletIcon sx={w20h20GreenIcon} />
                  </div>
                  <Typography className="green4 fs8 txt-semi-bold text-align-center">
                    Pay
                  </Typography>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {billDetails?.referenceNo?.length > 0 ? (
          <div className="flex-row-ali-cen mh20">
            <Typography className="font-bold fs12 black">
              Reference No:
            </Typography>
            <Typography className="font-bold fs12 gray4 ml5">
              {billDetails?.referenceNo}
            </Typography>
          </div>
        ) : null}

        <Container maxWidth="xl">
          <Box className="pb20 mt10 mh20Min">
            <TableContainer sx={{ maxHeight: 250 }}>
              <Table
                sx={{ minWidth: 200 }}
                aria-labelledby="tableTitle"
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    {phrTblHdrs?.map((hl, i) => (
                      <TableCell
                        key={i}
                        style={tblGrayBack}
                        sortDirection={false}
                        className={`table-header-text`}
                      >
                        <div
                          style={{
                            width:
                              hl === "serviceitemname"
                                ? 250
                                : hl === "discount"
                                  ? 100
                                  : hl === "qty" ||
                                      hl === "unitPrice" ||
                                      hl === "tax"
                                    ? 80
                                    : "auto",
                          }}
                        >
                          {tableNameExpan?.[hl]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getTabBasedRecords()?.length > 0 &&
                    getTabBasedRecords()
                      ?.filter((pd) => pd?.type === "consultation")
                      ?.map((con) => {
                        const reqObj = {
                          serviceitemname: `Consultation(${billDetails?.appointmentType})`,
                          qty: con?.quantity,
                          unitPrice: `Rs ${
                            Number(con?.price) > 0
                              ? Number(con?.price).toFixed(2)
                              : Number(con?.price)
                          }`,
                          tax:
                            Number(con?.tax) > 0
                              ? Number(con?.tax).toFixed(2)
                              : "-",
                          total: `Rs ${Number(con?.total).toFixed(2)}`,
                          days: con?.days ?? "-",
                        };
                        if (apnt?.appointmentStatus !== "completed") {
                          reqObj.pay = (
                            <div className="flex-row">
                              <div
                                className={
                                  activeTab === "Treatment" ? "" : "cursor"
                                }
                                onClick={() => {
                                  activeTab !== "Treatment" &&
                                    handleDelete(con);
                                }}
                              >
                                <div className="flex-center">
                                  <DeleteOutlineIcon sx={delBtn} />
                                </div>
                                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                  Delete
                                </Typography>
                              </div>
                              <div
                                className="cursor ml15"
                                onClick={() => handleEdit(con)}
                              >
                                <div className="flex-center">
                                  <EditIcon sx={w20h20BlueIcon} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Edit
                                </Typography>
                              </div>
                            </div>
                          );
                        }
                        return reqObj;
                      })
                      ?.map((bil, ind) => (
                        <TableRow tabIndex={-1} key={ind}>
                          {phrTblHdrs?.map((th, index) => (
                            <TableCell
                              key={index + th + "tr"}
                              component="th"
                              className="table-text-black capitalize"
                            >
                              <div
                                className="upload-row"
                                style={{
                                  width:
                                    th === "serviceitemname"
                                      ? 250
                                      : th === "discount"
                                        ? 100
                                        : th === "qty" ||
                                            th === "unitPrice" ||
                                            th === "tax"
                                          ? 80
                                          : "auto",
                                }}
                              >
                                <div>{bil[th]}</div>
                              </div>
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                  {getTabBasedRecords()?.length > 0 &&
                    (activeTab === "Treatment"
                      ? reorderList(
                          getTreatmentRecordBasedType(
                            billDetails?.paymentDetails,
                          ),
                        )
                      : activeTab === "Pet Shop"
                        ? getPetShopRecordBasedType(billDetails?.paymentDetails)
                        : getPharmacyRecordBasedType(
                            billDetails?.paymentDetails,
                          )
                    )
                      ?.filter((pd) => pd?.type !== "consultation")
                      ?.map((bil) => {
                        let reqTax =
                          selectedItem?.paymentDetailId === bil?.paymentDetailId
                            ? Number(
                                (Number(
                                  itemValues?.mrpPrice ??
                                    itemValues?.price ??
                                    0,
                                ) /
                                  100) *
                                  Number(itemValues?.tax ?? 0) *
                                  Number(itemValues?.quantity),
                              )?.toFixed(2)
                            : bil?.tax;

                        const reqTotal = bil?.total;
                        const isProcedureSubItem =
                          (bil?.procedureId ?? "")?.toString()?.length > 0 &&
                          // bil?.patientWorkbook &&
                          !bil?.mainProcedure;
                        const reqObj = {
                          ...bil,
                          isProcedureSubItem,
                          serviceitemname: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >
                              {bil?.name}
                            </div>
                          ),
                          qty: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >
                              {`${bil?.quantity}${
                                bil?.stockId && bil?.packageUom?.length > 0
                                  ? getRightPackageUom(bil?.packageUom)
                                  : ""
                              }`}
                            </div>
                          ),
                          unitPrice: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >{`Rs ${
                              Number(bil?.mrpPrice ?? bil?.price) > 0
                                ? Number(bil?.mrpPrice ?? bil?.price).toFixed(2)
                                : Number(bil?.mrpPrice ?? bil?.price)
                            }`}</div>
                          ),
                          discount:
                            Number(bil?.mrpDiscount ?? bil?.discount) > 0 ? (
                              <div
                                className={`fs12 font-bold ${
                                  isProcedureSubItem ? "green2" : "black"
                                }`}
                              >{`Rs ${Number(
                                bil?.mrpDiscount ?? bil?.discount,
                              ).toFixed(2)}`}</div>
                            ) : (
                              "-"
                            ),
                          total: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >{`Rs ${Number(bil?.reqTotal).toFixed(2)}`}</div>
                          ),
                          days: bil?.days ?? "-",
                          variantId: bil?.variantId ?? null,
                          serviceId: bil?.serviceId ?? null,
                        };
                        if (
                          apnt?.appointmentStatus !== "completed" &&
                          apnt?.checkOut !== "Y"
                        ) {
                          reqObj.pay = (
                            <div className="flex-row">
                              <div
                                className="cursor"
                                onClick={() => handleDelete(bil)}
                              >
                                <div className="flex-center">
                                  <DeleteOutlineIcon sx={delBtn} />
                                </div>
                                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                  Delete
                                </Typography>
                              </div>
                              <div
                                className="cursor ml15"
                                onClick={() => handleEdit(bil)}
                              >
                                <div className="flex-center">
                                  <EditIcon sx={w20h20BlueIcon} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Edit
                                </Typography>
                              </div>
                            </div>
                          );
                        }
                        reqObj.reqTotal =
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible
                            ? Number(reqTotal)
                            : (reqTotal ?? bil?.total);
                        reqObj.productId = itemValues?.productId;
                        reqObj.tax =
                          clinicDet?.pharmacyTaxId?.length > 0 ? (
                            reqTax > 0 ? (
                              <div
                                className={`fs12 font-bold ${
                                  isProcedureSubItem ? "green2" : "black"
                                }`}
                              >{`Rs ${Number(reqTax).toFixed(2)}`}</div>
                            ) : (
                              "-"
                            )
                          ) : (
                            "-"
                          );
                        return reqObj;
                      })
                      ?.map((bil, ind) => {
                        const reqList = bil?.reqList;
                        return (
                          <>
                            <TableRow tabIndex={-1} key={ind}>
                              {phrTblHdrs?.map((th, index) => {
                                return (
                                  <TableCell
                                    key={index + th + "tr"}
                                    component="th"
                                    className="table-text-black capitalize"
                                  >
                                    <div
                                      className="upload-row"
                                      style={{
                                        width:
                                          th === "serviceitemname"
                                            ? 250
                                            : th === "discount"
                                              ? 100
                                              : th === "qty" ||
                                                  th === "unitPrice" ||
                                                  th === "tax"
                                                ? 80
                                                : "auto",
                                      }}
                                    >
                                      <div>
                                        {th === "serviceitemname" ? (
                                          <div>
                                            {bil?.[th]}
                                            {bil?.stockId && (
                                              <div>
                                                <div className="fs10 gray4 font-medium">
                                                  Trade Name:{" "}
                                                  {bil?.tradeName ?? ""}
                                                </div>
                                                <div className="fs10 gray4 font-medium">
                                                  Batch No.:{" "}
                                                  {bil?.batchNo ?? ""} Expiry:{" "}
                                                  {bil?.expiryDate?.length > 0
                                                    ? moment(
                                                        new Date(
                                                          bil?.expiryDate,
                                                        ),
                                                      )?.format("DD MMM YYYY")
                                                    : ""}
                                                </div>
                                                {bil?.drugSchedule?.length >
                                                0 ? (
                                                  <div className="fs10 gray4 font-medium">
                                                    Drug Schedule:{" "}
                                                    {bil?.drugSchedule ?? ""}
                                                  </div>
                                                ) : null}
                                              </div>
                                            )}
                                          </div>
                                        ) : th === "total" ? (
                                          <div
                                            className={`fs12 font-bold ${
                                              bil?.isProcedureSubItem
                                                ? "green2"
                                                : "black"
                                            }`}
                                          >{`Rs ${Number(bil?.reqTotal).toFixed(
                                            2,
                                          )}`}</div>
                                        ) : typeof bil?.[th] === "number" ? (
                                          Number(bil?.[th]).toFixed(2)
                                        ) : (
                                          bil?.[th]
                                        )}
                                      </div>
                                    </div>
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                            {activeTab === "Treatment" &&
                              reqList?.map((itm) => {
                                const isDone = bil?.variantId
                                  ? true
                                  : itm?.status === "true";
                                return (
                                  <TableRow tabIndex={-1} key={ind}>
                                    {phrTblHdrs?.map((th, index) => (
                                      <TableCell
                                        key={index + th + "tr"}
                                        component="th"
                                        className="table-text-black capitalize"
                                      >
                                        <div
                                          className="upload-row"
                                          style={{
                                            width:
                                              th === "serviceitemname"
                                                ? 250
                                                : th === "discount"
                                                  ? 100
                                                  : th === "qty" ||
                                                      th === "unitPrice" ||
                                                      th === "tax"
                                                    ? 80
                                                    : "auto",
                                          }}
                                        >
                                          <div
                                            className={
                                              isDone
                                                ? "green-color"
                                                : "red-color"
                                            }
                                          >
                                            {th === "qty" ? (
                                              itm?.[th]
                                            ) : th === "total" ||
                                              th ===
                                                "discount" ? null : typeof itm?.[
                                                th
                                              ] === "number" ? (
                                              `Rs ${Number(itm?.[th]).toFixed(
                                                2,
                                              )}`
                                            ) : th === "serviceitemname" ? (
                                              <div className="flex-row-ali-cen">
                                                {isDone ? (
                                                  <img
                                                    src={require("../../../../assets/images/png/tick.png")}
                                                    className="img-wh15"
                                                  />
                                                ) : (
                                                  <img
                                                    src={require("../../../../assets/images/png/crossRed.png")}
                                                    className="img-wh15"
                                                  />
                                                )}
                                                <div className="pl10">
                                                  {itm?.[th]}
                                                </div>
                                              </div>
                                            ) : (
                                              itm?.[th]
                                            )}
                                          </div>
                                        </div>
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                );
                              })}
                          </>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Container>
        {searchVisible ? (
          <div className="mh20">
            <div className="ph10">
              <CustomTextField
                placeholder="Search"
                fullWidth
                handleChange={(e) => setSearchValue(e?.target?.value)}
                value={searchValue}
              />
            </div>
            {searchValue?.length > 0 ? (
              <div className="br8brblack pv10 ph10 mt10">
                <div className="flex-row mv5">
                  <div className="w25Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Name
                    </Typography>
                  </div>
                  <div className="w25Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Type
                    </Typography>
                  </div>
                  <div className="w25Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Category
                    </Typography>
                  </div>
                  <div className="w25Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Price
                    </Typography>
                  </div>
                </div>
                {getFilteredList()?.length > 0 ? (
                  <div className="scroll-100px">
                    {getFilteredList()?.map((fil, i) => {
                      return (
                        <div
                          className="bill-itm cursor"
                          key={i + "fil"}
                          onClick={() => handleAddItem(fil)}
                        >
                          <div className="w25Per">
                            <Typography className="txt-regular fs14">
                              {fil?.name}
                            </Typography>
                          </div>
                          <div className="w25Per">
                            <Typography className="txt-regular fs14">
                              {fil?.type}
                            </Typography>
                          </div>
                          <div className="w25Per">
                            <Typography className="txt-regular fs14">
                              {fil?.category}
                            </Typography>
                          </div>
                          <div className="w25Per">
                            <Typography className="txt-regular fs14">
                              {(fil?.servicePrice ??
                              fil?.stockBatch?.[0]?.unitSellingPrice)
                                ? `Rs ${Number(
                                    fil?.servicePrice ??
                                      fil?.stockBatch?.[0]?.unitSellingPrice,
                                  ).toFixed(2)}`
                                : "-"}
                            </Typography>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="flex-center mt20">
                    <Typography className="txt-regular">
                      No records available
                    </Typography>
                  </div>
                )}

                {getFilteredList()?.length > 0 ? null : (
                  <div className="flex-row flex-center">
                    <div className="flex-start">
                      <Typography className="fs14">{searchValue}</Typography>
                    </div>
                    <div className="flex1-end mt20">
                      <div className="w15Per">
                        <CustomButton
                          text="Add New"
                          smallBtn
                          onClick={() => handleAddItem()}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        ) : null}
        <div className="flex-row mt20">
          <div>
            {billDetails?.appointmentStatus !== "completed" &&
            (billDetails?.checkOut !== "Y" ||
              billDetails?.pharmacyCheckout !== "Y" ||
              billDetails?.petShopCheckout !== "Y") ? (
              <div className="flex-row ph10">
                <div>
                  <CustomButton
                    text="Add"
                    smallBtn
                    onClick={() => setSearchVisible(true)}
                  />
                </div>
                <div className="ml15">
                  <CustomButton
                    text={`${
                      Number(
                        (activeTab === "Treatment"
                          ? billDetails?.treatmentDiscountValue
                          : activeTab === "Pharmacy"
                            ? billDetails?.pharmacyDiscountValue
                            : billDetails?.petShopDiscountValue) ?? 0,
                      ) > 0
                        ? "Edit"
                        : "Apply"
                    } Discount`}
                    smallBtn
                    onClick={handleApplyDiscount}
                  />
                </div>
              </div>
            ) : null}

            {(billDetails?.checkOut !== "Y" ||
              billDetails?.pharmacyCheckout !== "Y" ||
              billDetails?.petShopCheckout !== "Y") &&
            billDetails?.appointmentStatus === "finalize" ? (
              <div className="flex-row ph10 mt20">
                <div className="w100Per">
                  <CustomSelect
                    list={getBilledByList()}
                    value={billedByValues?.billedBy ?? null}
                    search
                    label="Billed By"
                    handleChange={(e, value) => {
                      setBilledByValues({
                        billedBy: value,
                        error: value?.value ? false : true,
                      });
                    }}
                    error={billedByValues?.error ?? false}
                    helperText={
                      billedByValues?.error ? "This field is required" : ""
                    }
                  />
                </div>
              </div>
            ) : null}
          </div>

          <div className="flex1-end ph20 mtMin5">
            <div className="w100Per flex-column">
              <div className="flex1-end">
                <div className="w40Per">
                  <div className="flex-row-between-align-center">
                    <div className="txtstyle">Discount</div>
                    <div className="txtstyle">
                      {Number(
                        (activeTab === "Treatment"
                          ? getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                            )
                          : activeTab === "Pharmacy"
                            ? getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                            : getTaxAndSubTotalAndTotal(
                                getPetShopRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )
                        )?.discount,
                      ) > 0
                        ? `Rs ${Number(
                            (activeTab === "Treatment"
                              ? getTaxAndSubTotalAndTotalForTreatment(
                                  getTreatmentRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                )
                              : activeTab === "Pharmacy"
                                ? getTaxAndSubTotalAndTotal(
                                    getPharmacyRecordBasedType(
                                      billDetails?.paymentDetails,
                                    ),
                                  )
                                : getTaxAndSubTotalAndTotal(
                                    getPetShopRecordBasedType(
                                      billDetails?.paymentDetails,
                                    ),
                                  )
                            )?.discount,
                          )?.toFixed(2)}`
                        : "-"}
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="txtstyle">
                      {activeTab === "Treatment"
                        ? "Treatment"
                        : activeTab === "Pet Shop"
                          ? "Pet Shop"
                          : "Pharmacy"}{" "}
                      Subtotal
                    </div>
                    <div className="txtstyle">
                      Rs{" "}
                      {Number(
                        Number(
                          (activeTab === "Treatment"
                            ? getTaxAndSubTotalAndTotalForTreatment(
                                getTreatmentRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                                services?.data,
                                lastSummary?.procedures ?? [],
                              )
                            : getTaxAndSubTotalAndTotal(
                                activeTab === "Pet Shop"
                                  ? getPetShopRecordBasedType(
                                      billDetails?.paymentDetails,
                                    )
                                  : getPharmacyRecordBasedType(
                                      billDetails?.paymentDetails,
                                    ),
                              )
                          )?.subTotal,
                        ) -
                          Number(
                            (activeTab === "Treatment"
                              ? getTaxAndSubTotalAndTotalForTreatment(
                                  getTreatmentRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                  services?.data,
                                  lastSummary?.procedures ?? [],
                                )
                              : getTaxAndSubTotalAndTotal(
                                  activeTab === "Pet Shop"
                                    ? getPetShopRecordBasedType(
                                        billDetails?.paymentDetails,
                                      )
                                    : getPharmacyRecordBasedType(
                                        billDetails?.paymentDetails,
                                      ),
                                )
                            )?.tax,
                          ) +
                          Number(
                            (activeTab === "Treatment"
                              ? getTaxAndSubTotalAndTotalForTreatment(
                                  getTreatmentRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                  services?.data,
                                  lastSummary?.procedures ?? [],
                                )
                              : getTaxAndSubTotalAndTotal(
                                  activeTab === "Pet Shop"
                                    ? getPetShopRecordBasedType(
                                        billDetails?.paymentDetails,
                                      )
                                    : getPharmacyRecordBasedType(
                                        billDetails?.paymentDetails,
                                      ),
                                )
                            )?.discount,
                          ) -
                          (activeTab === "Treatment"
                            ? getTaxAndSubTotalAndTotalForTreatment(
                                getTreatmentRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                                services?.data,
                                lastSummary?.procedures ?? [],
                              )?.adminCharge
                            : 0),
                      )?.toFixed(2)}
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="txtstyle">Taxes (CGST) </div>
                    <div className="txtstyle">
                      {Number(
                        getTaxAndSubTotalAndTotal(
                          activeTab === "Pet Shop"
                            ? getPetShopRecordBasedType(
                                billDetails?.paymentDetails,
                              )
                            : activeTab === "Pharmacy"
                              ? getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                )
                              : getTreatmentRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                        )?.tax,
                      ) /
                        2 >
                      0
                        ? `Rs ${Number(
                            Number(
                              getTaxAndSubTotalAndTotal(
                                activeTab === "Pet Shop"
                                  ? getPetShopRecordBasedType(
                                      billDetails?.paymentDetails,
                                    )
                                  : activeTab === "Pharmacy"
                                    ? getPharmacyRecordBasedType(
                                        billDetails?.paymentDetails,
                                      )
                                    : getTreatmentRecordBasedType(
                                        billDetails?.paymentDetails,
                                      ),
                              )?.tax,
                            ) / 2,
                          )?.toFixed(2)}`
                        : "-"}
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="txtstyle">Taxes (SGST) </div>
                    <div className="txtstyle">
                      {Number(
                        getTaxAndSubTotalAndTotal(
                          activeTab === "Pet Shop"
                            ? getPetShopRecordBasedType(
                                billDetails?.paymentDetails,
                              )
                            : activeTab === "Pharmacy"
                              ? getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                )
                              : getTreatmentRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                        )?.tax,
                      ) /
                        2 >
                      0
                        ? `Rs ${Number(
                            Number(
                              getTaxAndSubTotalAndTotal(
                                activeTab === "Pet Shop"
                                  ? getPetShopRecordBasedType(
                                      billDetails?.paymentDetails,
                                    )
                                  : activeTab === "Pharmacy"
                                    ? getPharmacyRecordBasedType(
                                        billDetails?.paymentDetails,
                                      )
                                    : getTreatmentRecordBasedType(
                                        billDetails?.paymentDetails,
                                      ),
                              )?.tax,
                            ) / 2,
                          )?.toFixed(2)}`
                        : "-"}
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="txtstyle">Round Off</div>
                    <div className="txtstyle">
                      Rs{" "}
                      {
                        roundWithSignedDiff(
                          Number(
                            (activeTab === "Treatment"
                              ? getTaxAndSubTotalAndTotalForTreatment(
                                  getTreatmentRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                  services?.data,
                                  lastSummary?.procedures ?? [],
                                )
                              : getTaxAndSubTotalAndTotal(
                                  activeTab === "Pet Shop"
                                    ? getPetShopRecordBasedType(
                                        billDetails?.paymentDetails,
                                      )
                                    : getPharmacyRecordBasedType(
                                        billDetails?.paymentDetails,
                                      ),
                                )
                            )?.subTotal,
                          ),
                        )?.difference
                      }
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="txt-semi-bold fs14 blue-color">
                      {" "}
                      {activeTab === "Treatment"
                        ? "Treatment"
                        : activeTab === "Pet Shop"
                          ? "Pet Shop"
                          : "Pharmacy"}{" "}
                      Total
                    </div>
                    <div className="txt-semi-bold fs14 blue-color">
                      Rs{" "}
                      {roundWithSignedDiff(
                        Number(
                          (activeTab === "Treatment"
                            ? getTaxAndSubTotalAndTotalForTreatment(
                                getTreatmentRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                                services?.data,
                                lastSummary?.procedures ?? [],
                              )
                            : getTaxAndSubTotalAndTotal(
                                activeTab === "Pet Shop"
                                  ? getPetShopRecordBasedType(
                                      billDetails?.paymentDetails,
                                    )
                                  : getPharmacyRecordBasedType(
                                      billDetails?.paymentDetails,
                                    ),
                              )
                          )?.subTotal,
                        ),
                      )?.rounded?.toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {prntPrevVsble ? (
        <BillingPreview
          selectedBill={billDetails}
          modVsble={prntPrevVsble}
          onClosePreview={() => {
            setPrntPrevVsble(false);
          }}
        />
      ) : null}

      <CustomModal
        open={editModVsble}
        onClose={onCloseEditMod}
        header="Edit"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-90vh ph10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold fs14 gray4">
                Sevice / Item Name
              </Typography>
              <CustomTextField
                value={itemValues?.name}
                handleChange={(e) =>
                  onChangeItemValue("name", e?.target?.value)
                }
                fullWidth
                disabled
              />
            </Grid>
            {itemValues?.stockId ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs14 gray4">
                  Batch Number
                </Typography>
                <CustomSelect
                  list={getBatches(itemValues?.stockId)}
                  value={itemValues?.batchNumber}
                  handleChange={(e, value) => {
                    onChangeItemValue("batchNumber", value);
                  }}
                  search
                  isBatchNumber
                />
              </Grid>
            ) : null}
            {isProcedurePresent() ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs14 gray4">
                  Link To Procedure
                </Typography>
                <CustomSelect
                  list={getProcedureList()}
                  value={itemValues?.linkToProcedure}
                  handleChange={(e, value) => {
                    onChangeItemValue("linkToProcedure", value);
                  }}
                  search
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">Quantity</Typography>
              <CustomTextField
                value={itemValues?.quantity}
                handleChange={(e) =>
                  onChangeItemValue("quantity", e?.target?.value)
                }
                fullWidth
                type="number"
                suffix={
                  itemValues?.stockId ? (
                    getRightPackageUom(
                      getBatch(
                        itemValues?.stockId,
                        itemValues?.batchNumber?.batchId ?? itemValues?.batchId,
                      )?.packageUom,
                    )?.length > 0 ? (
                      <Custom3dotString
                        str={`${getRightPackageUom(
                          getBatch(
                            itemValues?.stockId,
                            itemValues?.batchNumber?.batchId ??
                              itemValues?.batchId,
                          )?.packageUom,
                        )}`}
                        length={9}
                        className="fs12 font-medium"
                      />
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">
                Unit Price
              </Typography>
              <CustomTextField
                value={itemValues?.price}
                handleChange={(e) =>
                  onChangeItemValue("price", e?.target?.value)
                }
                fullWidth
                type="number"
                disabled={
                  !itemValues?.batchId &&
                  !itemValues?.stockId &&
                  !itemValues?.productId
                    ? false
                    : true
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">
                Unit Discount
                {/* {itemValues?.discountType?.value !== "code"
                  ? `Discount
                ${
                  itemValues?.discountType?.value?.toLowerCase() === "price"
                    ? "Price"
                    : "Percentage"
                }`
                  : "Discount Code"} */}
              </Typography>
              {itemValues?.discountType?.value === "code" ? (
                <CustomSelect
                  list={getDiscountCodes()}
                  name="discountValue"
                  value={itemValues?.discountValue}
                  handleChange={(e, value) =>
                    onChangeItemValue("discountValue", value)
                  }
                  search
                  error={getTaxDiscountAndTotal(itemValues)?.isHigherDiscount}
                  helperText={
                    getTaxDiscountAndTotal(itemValues)?.isHigherDiscount
                      ? "Discount cannot be greater than unit price"
                      : ""
                  }
                />
              ) : (
                <CustomTextField
                  name="discountValue"
                  fullWidth
                  handleChange={(e) =>
                    onChangeItemValue("discountValue", e?.target?.value)
                  }
                  value={itemValues?.discountValue}
                  type="number"
                  error={getTaxDiscountAndTotal(itemValues)?.isHigherDiscount}
                  helperText={
                    getTaxDiscountAndTotal(itemValues)?.isHigherDiscount
                      ? "Discount cannot be greater than unit price"
                      : ""
                  }
                  mandatoryField
                />
              )}
              {/* <CustomTextField
                value={itemValues?.discountValue}
                handleChange={(e) =>
                  onChangeItemValue("discountValue", e?.target?.value)
                }
                fullWidth
                type="number"
              /> */}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">
                Discount Type
              </Typography>
              <CustomSelect
                list={dropDiscountTypes}
                value={itemValues?.discountType}
                handleChange={(e, value) => {
                  onChangeItemValue("discountType", value);
                }}
                search
              />
            </Grid>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 gray17">
                Discount
              </Typography>
              <Typography className="txt-semi-bold fs14 gray17 pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.discount) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.discount,
                    ).toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 gray17">Tax</Typography>
              <Typography className="txt-semi-bold fs14 gray17 pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.tax) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.tax,
                    ).toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 blue-color">
                Item Total
              </Typography>
              <Typography className="txt-semi-bold fs14 blue-color pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.total) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.total,
                    )?.toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
          </Grid>
          <div className="flex1-center mv20">
            <div>
              <CustomButton
                text="Update"
                smallBtn
                onClick={() => handleUpdateItem(itemValues)}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={disModVsble}
        onClose={onDiscountModClose}
        header="Apply Discount"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={0.5} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 selectypetext ">
              Discount Type
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Checkbox
              radio
              onChange={(e) => onChangeDiscount("type", e?.target?.value)}
              radios={radioDiscountTypes}
              defaultValue={disValues?.type}
            />
          </Grid>
          {disValues?.type === "code" ? (
            <CustomSelect
              list={getDiscountCodes()}
              name="discountCode"
              value={disValues?.discountCode}
              handleChange={(e, value) =>
                onChangeDiscount("discountCode", value)
              }
              search
              error={!!disErrs?.discountCode}
              helperText={disErrs?.discountCode}
            />
          ) : (
            <CustomTextField
              label={`Discount  ${
                disValues?.type?.toLowerCase() === "price"
                  ? "Price"
                  : "Percentage"
              }`}
              name="amt"
              fullWidth
              handleChange={(e) => onChangeDiscount("amt", e?.target?.value)}
              value={disValues?.amt}
              labelTop
              type="number"
              error={!!disErrs?.amt}
              helperText={disErrs?.amt}
              mandatoryField
            />
          )}
          {((activeTab === "Treatment"
            ? billDetails?.treatmentDiscountValue
            : activeTab === "Pharmacy"
              ? billDetails?.pharmacyDiscountValue
              : billDetails?.petShopDiscountValue) ?? 0) > 0 ? (
            <div
              className="flex-row-ali-cen cursor"
              onClick={() => handleAddDiscount(true)}
            >
              <Typography className="font-medium fs14 red-color mr5">
                Remove Discount
              </Typography>
              <CloseIcon
                sx={{
                  color: AppColors.red,
                  width: 15,
                  height: 15,
                  stroke: AppColors.red,
                  strokeWidth: 2,
                }}
              />
            </div>
          ) : null}
          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Add"
                onClick={() => handleAddDiscount(false)}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure want to delete the list?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleDelConfirm}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={payModalVisible}
        onClose={payModClose}
        header="Pay"
        rightModal
        modalWidth={30}
      >
        <div className="flex-center">
          <Card
            sx={{
              borderRadius: 1,
              padding: 2,
              borderTopColor: `${getBorderColor(billDetails?.status)}`,
            }}
            className="pay-card"
          >
            <div className="flex-row">
              <div className="w50Per">
                <Typography className="fs12 txt-semi-bold gray14">
                  Pet Name
                </Typography>
                <Typography className="fs14 txt-semi-bold black">
                  {petDet?.petName}
                </Typography>
              </div>
              <div className="w50Per">
                <Typography className="fs12 txt-semi-bold gray14">
                  Parent Name
                </Typography>
                <Typography className="fs14 txt-semi-bold black">
                  {petDet?.userName}
                </Typography>
              </div>
            </div>
            <div className="mh20Min">
              <div className="gry-hor-split3 mv5" />
            </div>
            <div className="mt10">
              <Typography className="txt-regular fs14 gray7">
                {moment(new Date(billDetails?.createdDate)).format(
                  "DD MMM, YYYY",
                )}
              </Typography>
              <div className="bil-his-box mt5">
                <div className="flex-row">
                  <div className="flex-start">
                    <Typography className="fs14 font-medium black">
                      {billDetails?.invoiceNumbers}
                    </Typography>
                  </div>
                  <div className="flex1-end">
                    <Typography className="txt-semi-bold fs14 orange3">
                      {Number(
                        Number(
                          roundWithSignedDiff(
                            getTaxAndSubTotalAndTotalForTreatment(
                              getTreatmentRecordBasedType(
                                billDetails?.paymentDetails,
                              ),
                              services?.data,
                              lastSummary?.procedures ?? [],
                            )?.subTotal,
                          )?.rounded +
                            roundWithSignedDiff(
                              getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )?.subTotal,
                            )?.rounded +
                            roundWithSignedDiff(
                              getTaxAndSubTotalAndTotal(
                                getPetShopRecordBasedType(
                                  billDetails?.paymentDetails,
                                ),
                              )?.subTotal,
                            )?.rounded,
                        ) - Number(billDetails?.amtPaid ?? 0),
                      ) > 0
                        ? `Rs ${Number(
                            Number(
                              roundWithSignedDiff(
                                getTaxAndSubTotalAndTotalForTreatment(
                                  getTreatmentRecordBasedType(
                                    billDetails?.paymentDetails,
                                  ),
                                  services?.data,
                                  lastSummary?.procedures ?? [],
                                )?.subTotal,
                              )?.rounded +
                                roundWithSignedDiff(
                                  getTaxAndSubTotalAndTotal(
                                    getPharmacyRecordBasedType(
                                      billDetails?.paymentDetails,
                                    ),
                                  )?.subTotal,
                                )?.rounded +
                                roundWithSignedDiff(
                                  getTaxAndSubTotalAndTotal(
                                    getPetShopRecordBasedType(
                                      billDetails?.paymentDetails,
                                    ),
                                  )?.subTotal,
                                )?.rounded,
                            ) - Number(billDetails?.amtPaid ?? 0),
                          )?.toFixed(2)}`
                        : "Nil"}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            {apnt?.appointmentType ? (
              <div
                className={`conttype ${
                  apnt?.appointmentType === "Physical"
                    ? "card-con-blue-back"
                    : "virtual-bg-color"
                }`}
              >
                {apnt?.appointmentType}
              </div>
            ) : null}
          </Card>
        </div>
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <CustomTextField
              label="Amount"
              name="amount"
              fullWidth
              handleChange={(e) =>
                handleChangeValues("amount", e?.target?.value)
              }
              value={payValues?.amount}
              helperText={payErr?.amount}
              error={!!payErr?.amount}
              labelTop
              type="number"
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="font-medium fs14 black2">Payment Mode</div>
            {/* <Select
              list={
                (profile?.id || profile?.createdBy) === RMVClinicId
                  ? RMVPaymentTypeList
                  : enabledPaymentTypes
              }
              value={payValues?.paymentMode}
              helperText={payErr?.paymentMode}
              error={!!payErr?.paymentMode}
              handleChange={(e, value) =>
                handleChangeValues("paymentMode", value)
              }
              name="paymentMode"
              search
            /> */}
            <PaymentModeDropdown
              list={
                (profile?.id || profile?.createdBy) === RMVClinicId
                  ? RMVPaymentTypeList
                  : enabledPaymentTypes
              }
              value={payValues?.paymentMode}
              error={!!payErr?.paymentMode}
              helperText={payErr?.paymentMode}
              onChange={(e, value) => handleChangeValues("paymentMode", e)}
              name="paymentMode"
              label=""
            />
          </Grid>
          {payValues?.paymentMode?.value === "advanceAdjustment" ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="txt-semi-bold fs14 orange5">
                Available Balance:{" "}
                {Number(billDetails?.advanceAmount) > 0
                  ? Number(billDetails?.advanceAmount)?.toFixed(2)
                  : "-"}
              </Typography>
            </Grid>
          ) : null}
          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Pay" onClick={finalPayment} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </div>
  );
};

export default Billing;
